// import React, { useState, useEffect, useMemo } from 'react';
// import CategoryList from '../../components/CategoryList/CategoryList';
// import BannerProduct from '../../components/BannerProduct/BannerProduct';
// import HorizontalCardProduct from '../../components/HorizontalCardProduct/HorizontalCardProduct';
// import VerticalCardProduct from '../../components/VerticalCardProduct/VerticalCardProduct';
// import NewsletterBox from '../../components/NewsletterBox/NewsletterBox';
// import { useTheme } from '../../components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeft } from 'lucide-react';
// import FeaturedDealsBanner from 'components/Deals/FeaturedDealsBanner';

// function Home() {
//     const { colors } = useTheme();
//     const navigate = useNavigate();
//     const [visibleSections, setVisibleSections] = useState({
//         banner: true,
//         smartphones: false,
//         tablets: false,
//         laptops: false,
//         smartwatches: false,
//         drones: false,
//         accessories: false,
//         games: false,
//         newsletter: false
//     });

//     useEffect(() => {
//         // Load first sections immediately
//         setVisibleSections(prev => ({
//             ...prev,
//             smartphones: true,
//             laptops: true
//         }));

//         // Lazy load the rest
//         const timer = setTimeout(() => {
//             setVisibleSections(prev => ({
//                 ...prev,
//                 tablets: true,
//                 smartwatches: true,
//                 drones: true,
//                 accessories: true,
//                 games: true,
//                 newsletter: true
//             }));
//         }, 300);

//         return () => clearTimeout(timer);
//     }, []);

//     // Section skeleton loader
//     const SectionSkeleton = () => (
//         <div className="space-y-4">
//             <div className="h-8 bg-slate-200 dark:bg-slate-800 rounded w-1/3 animate-pulse"></div>
//             <div className="flex gap-4 overflow-hidden">
//                 {[...Array(4)].map((_, i) => (
//                     <div key={i} className="min-w-[280px] h-48 bg-slate-200 dark:bg-slate-800 rounded-lg animate-pulse"></div>
//                 ))}
//             </div>
//         </div>
//     );

//     // Product section wrapper
//     const ProductSection = ({ 
//         id, 
//         title, 
//         emoji, 
//         description, 
//         component: Component, 
//         props, 
//         isVisible 
//     }) => (
//         <section 
//             id={`section-${id}`}
//             className="mb-12 transition-opacity duration-500"
//             style={{ backgroundColor: colors.bg }}
//         >
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 {/* Section Header */}
//                 <div className="mb-8">
//                     <div className="flex items-center gap-3 mb-3">
//                         <h2 
//                             className="text-3xl md:text-4xl font-black"
//                             style={{ color: colors.text }}
//                         >
//                             <span className="mr-3">{emoji}</span>
//                             {title}
//                         </h2>
//                     </div>
//                     <p 
//                         className="text-lg"
//                         style={{ color: colors.textSecondary }}
//                     >
//                         {description}
//                     </p>
//                     <div 
//                         className="h-1 w-20 mt-4 rounded-full"
//                         style={{ backgroundColor: colors.primary }}
//                     />
//                 </div>

//                 {/* Content */}
//                 {isVisible ? (
//                     <div className="animate-fadeIn">
//                         <Component {...props} />
//                     </div>
//                 ) : (
//                     <SectionSkeleton />
//                 )}
//             </div>
//         </section>
//     );

//     const goBack = ()=>{
//         navigate("/landing");
//     }

//     return (
//         <div 
//             style={{ 
//                 backgroundColor: colors.bg, 
//                 minHeight: '100vh',
//                 transition: 'background-color 0.3s ease'
//             }}
//         >
                      
//             {/* Hero Section */}
//             <section
//                 className="relative overflow-hidden pt-24 pb-16 md:pt-32 md:pb-24"
//                 style={{
//                     background: `linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.accentLight} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <button onClick={goBack} className="mb-8 text-white font-semibold underline">
//                     <ArrowLeft className="inline-block w-4 h-4 ml-1" /> Go Back 
//                     </button>
//                     <div className="text-center">
//                         <h1
//                             className="text-5xl md:text-6xl font-black mb-6 leading-tight"
//                             style={{ color: colors.text }}
//                         >
//                             Discover Your <span style={{ color: colors.primary }}>Next</span> Favorite
//                         </h1>
//                         <p
//                             className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto"
//                             style={{ color: colors.textSecondary }}
//                         >
//                             Shop premium phones and gadgets with exclusive deals
//                         </p>
//                         <div 
//                             className="inline-block px-8 py-3 rounded-full font-bold text-white animate-pulse"
//                             style={{ backgroundColor: colors.primary }}
//                         >
//                             New Arrivals Added Daily
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* Category List - Always visible */}
//             <section 
//                 className="py-12"
//                 style={{ backgroundColor: colors.bgSecondary }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <h2 
//                         className="text-3xl font-black mb-8"
//                         style={{ color: colors.text }}
//                     >
//                         Browse by Category
//                     </h2>
//                     <CategoryList />
//                 </div>
//             </section>

//             {/* Banner - Always visible */}
//             <section className="py-12" style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     <BannerProduct />
//                 </div>
//             </section>

//             <div>
//             <FeaturedDealsBanner onViewAllDeals={() => navigate('/flashdeals')} />
//           </div>

//             {/* Lazy Loaded Product Sections */}
//             <div style={{ backgroundColor: colors.bg }}>
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//                     {/* Smartphones */}
//                     <ProductSection
//                         id="smartphones"
//                         title="Latest Smartphones"
//                         emoji="📱"
//                         description="Cutting-edge smartphones from top brands"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: "smartphones",
//                             heading: "Premium Smartphones"
//                         }}
//                         isVisible={visibleSections.smartphones}
//                     />

//                     {/* Laptops */}
//                     <ProductSection
//                         id="laptops"
//                         title="Powerful Laptops"
//                         emoji="💻"
//                         description="High-performance laptops for work and gaming"
//                         component={HorizontalCardProduct}
//                         props={{
//                             productsCategory: "laptops",
//                             heading: "Laptops & Notebooks"
//                         }}
//                         isVisible={visibleSections.laptops}
//                     />

//                     {/* Tablets */}
//                     <ProductSection
//                         id="tablets"
//                         title="Versatile Tablets"
//                         emoji="📟"
//                         description="Perfect blend of productivity and entertainment"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "tablets",
//                             heading: "Tablets & iPads"
//                         }}
//                         isVisible={visibleSections.tablets}
//                     />

//                     {/* Smart Watches */}
//                     <ProductSection
//                         id="smartwatches"
//                         title="Smart Watches"
//                         emoji="⌚"
//                         description="Stay connected and track your fitness"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "smart-watches",
//                             heading: "Smart Watches"
//                         }}
//                         isVisible={visibleSections.smartwatches}
//                     />

//                     {/* Drones */}
//                     <ProductSection
//                         id="drones"
//                         title="Professional Drones"
//                         emoji="🚁"
//                         description="Capture stunning aerial photography"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "drones",
//                             heading: "DJI Drones"
//                         }}
//                         isVisible={visibleSections.drones}
//                     />

//                     {/* Accessories */}
//                     <ProductSection
//                         id="accessories"
//                         title="Tech Accessories"
//                         emoji="🔌"
//                         description="Essential accessories for your devices"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "accessories",
//                             heading: "Chargers & Powerbanks"
//                         }}
//                         isVisible={visibleSections.accessories}
//                     />

//                     {/* Games Consoles */}
//                     <ProductSection
//                         id="games"
//                         title="Gaming Consoles"
//                         emoji="🎮"
//                         description="Next-gen gaming experience"
//                         component={VerticalCardProduct}
//                         props={{
//                             productsCategory: "games-consoles",
//                             heading: "Gaming & VR"
//                         }}
//                         isVisible={visibleSections.games}
//                     />
//                 </div>
//             </div>

//             {/* Newsletter */}
//             <section 
//                 id="section-newsletter"
//                 className="py-12"
//                 style={{ 
//                     background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.accent} 100%)`
//                 }}
//             >
//                 <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                     {visibleSections.newsletter ? (
//                         <div className="animate-fadeIn">
//                             <NewsletterBox />
//                         </div>
//                     ) : (
//                         <div className="h-32 bg-white/10 rounded-lg animate-pulse"></div>
//                     )}
//                 </div>
//             </section>

//             <style jsx>{`
//                 @keyframes fadeIn {
//                     from {
//                         opacity: 0;
//                     }
//                     to {
//                         opacity: 1;
//                     }
//                 }

//                 .animate-fadeIn {
//                     animation: fadeIn 0.5s ease-out;
//                 }

//                 @keyframes pulse {
//                     0%, 100% {
//                         opacity: 1;
//                     }
//                     50% {
//                         opacity: 0.5;
//                     }
//                 }

//                 .animate-pulse {
//                     animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//                 }
//             `}</style>
//         </div>
//     );
// }

// export default Home;


// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { 
//   ShoppingBag, 
//   Headphones, 
//   Shield, 
//   Truck, 
//   ArrowRight,
//   Star,
//   Search,
//   ShoppingCart,
//   ChevronRight,
//   Package,
//   RefreshCw,
//   Phone,
//   Zap,
//   Award,
//   TrendingUp,
//   Heart,
//   Sparkles,
//   Gift,
//   CheckCircle2,
//   Eye // Add Eye icon for consistency
// } from 'lucide-react';
// import { useTheme } from 'components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import addToCart from 'helpers/addToCart';
// import Context from "../../context";
// import LikeButton from '../../components/ProductLike/LikeButton'; 
// import { summaryApi } from "../../common"; 

// gsap.registerPlugin(ScrollTrigger);

// const Home = () => {
//   const { colors } = useTheme();
//   const { fetchUserAddToCart } = useContext(Context);
//   const [scrolled, setScrolled] = useState(false);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [productRatings, setProductRatings] = useState({});
//   const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
//   const heroRef = useRef(null);
//   const featuresRef = useRef(null);
//   const productsRef = useRef(null);
//   const servicesRef = useRef(null);
//   const navigate = useNavigate()

//   const { scrollYProgress } = useScroll();
//   const scaleProgress = useSpring(scrollYProgress, {
//     stiffness: 100,
//     damping: 30,
//     restDelta: 0.001
//   });

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 20);
//     window.addEventListener('scroll', handleScroll);
    
//     const handleMouseMove = (e) => {
//       setCursorPosition({ x: e.clientX, y: e.clientY });
//     };
//     window.addEventListener('mousemove', handleMouseMove);

//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//       window.removeEventListener('mousemove', handleMouseMove);
//     };
//   }, []);

//   useEffect(() => {
//     // Hero title animation
//     gsap.fromTo('.hero-title-word',
//       { 
//         y: 100, 
//         opacity: 0,
//         rotationX: -90
//       },
//       {
//         y: 0,
//         opacity: 1,
//         rotationX: 0,
//         duration: 1.2,
//         stagger: 0.1,
//         ease: 'power4.out',
//         scrollTrigger: {
//           trigger: heroRef.current,
//           start: 'top 80%'
//         }
//       }
//     );

//     // Floating animation for hero elements
//     gsap.to('.floating-element', {
//       y: -30,
//       duration: 2.5,
//       repeat: -1,
//       yoyo: true,
//       ease: 'sine.inOut',
//       stagger: 0.2
//     });

//     // Products reveal animation
//     gsap.fromTo('.product-reveal',
//       {
//         scale: 0.8,
//         opacity: 0,
//         rotationY: 45,
//       },
//       {
//         scale: 1,
//         opacity: 1,
//         rotationY: 0,
//         duration: 1,
//         stagger: 0.15,
//         ease: 'back.out(1.5)',
//         scrollTrigger: {
//           trigger: productsRef.current,
//           start: 'top 70%',
//           toggleActions: 'play none none reverse'
//         }
//       }
//     );

//     // Service cards stagger
//     gsap.fromTo('.service-card',
//       {
//         x: -100,
//         opacity: 0,
//         rotationY: -30
//       },
//       {
//         x: 0,
//         opacity: 1,
//         rotationY: 0,
//         duration: 1.2,
//         stagger: 0.2,
//         ease: 'power3.out',
//         scrollTrigger: {
//           trigger: servicesRef.current,
//           start: 'top 70%'
//         }
//       }
//     );

//     // Parallax effect for images
//     gsap.utils.toArray('.parallax-img').forEach((img) => {
//       gsap.to(img, {
//         y: -50,
//         ease: 'none',
//         scrollTrigger: {
//           trigger: img,
//           start: 'top bottom',
//           end: 'bottom top',
//           scrub: 1
//         }
//       });
//     });
//   }, []);

//   const heroProducts = [
//     {
//       id: 1,
//       name: "iPhone 15 Pro Max",
//       tagline: "Titanium. So strong. So light.",
//       price: "₦24,999",
//       image: "https://images.unsplash.com/photo-1678652197831-2d180705cd2c?w=800&h=800&fit=crop",
//       badge: "NEW",
//       color: "from-blue-500 to-purple-600"
//     },
//     {
//       id: 2,
//       name: "AirPods Pro",
//       tagline: "Adaptive Audio. Now playing.",
//       price: "₦5,999",
//       image: "https://images.unsplash.com/photo-1606841837239-c5a1a4a07af7?w=800&h=800&fit=crop",
//       badge: "POPULAR",
//       color: "from-purple-500 to-pink-600"
//     },
//     {
//       id: 3,
//       name: "Apple Watch Ultra",
//       tagline: "Adventure awaits.",
//       price: "₦18,999",
//       image: "https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=800&h=800&fit=crop",
//       badge: "FEATURED",
//       color: "from-orange-500 to-red-600"
//     }
//   ];

//   console.log("featuredProducts:", featuredProducts);


//   const fetchProductRating = async (productId) => {
//   try {
//     const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
//       method: summaryApi.getReviews.method,
//       credentials: 'include'
//     });
//     const data = await response.json();
    
//     if (data.data && data.data.length > 0) {
//       const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
//       const averageRating = totalRating / data.data.length;
      
//       setProductRatings(prev => ({
//         ...prev,
//         [productId]: {
//           average: averageRating,
//           count: data.data.length
//         }
//       }));
//     }
//   } catch (error) {
//     console.error(`Error fetching rating for product ${productId}:`, error);
//   }
// }

//   // Fetch real featured products from backend
//  useEffect(() => {
//   const fetchFeaturedProducts = async () => {
//     try {
//       setLoadingProducts(true);
//       const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//       const response = await fetch(`${backendUrl}/api/product/featured-products`);
//       const data = await response.json();
      
//       if (data.success && data.data) {
//         setFeaturedProducts(data.data);
//         // Fetch ratings for each featured product
//         data.data.forEach(product => {
//           fetchProductRating(product._id);
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching featured products:', error);
//     } finally {
//       setLoadingProducts(false);
//     }
//   };

//   fetchFeaturedProducts();
// }, []);


//   const services = [
//     {
//       icon: <Shield className="w-12 h-12" />,
//       label: "PROTECTION",
//       title: "Extended Warranty & Insurance",
//       description: "Comprehensive coverage for all your devices with screen repair included.",
//       gradient: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//       stats: "2-Year Coverage"
//     },
//     {
//       icon: <Phone className="w-12 h-12" />,
//       label: "CONNECTIVITY",
//       title: "All Networks Available",
//       description: "Choose from all major carriers. Get the best deals and plans.",
//       gradient: `linear-gradient(135deg, ${colors.accent}, #EC4899)`,
//       stats: "3 Networks"
//     },
//     {
//       icon: <Headphones className="w-12 h-12" />,
//       label: "SUPPORT",
//       title: "24/7 Expert Assistance",
//       description: "From setup to troubleshooting, we're here to help anytime.",
//       gradient: `linear-gradient(135deg, #F59E0B, #EF4444)`,
//       stats: "Always Online"
//     },
//     {
//       icon: <RefreshCw className="w-12 h-12" />,
//       label: "TRADE-IN",
//       title: "Maximum Value Guaranteed",
//       description: "Trade in your old device and get instant cash back on new purchases.",
//       gradient: `linear-gradient(135deg, ${colors.success}, #059669)`,
//       stats: "Up to ₦15,000"
//     }
//   ];

//   const features = [
//     { icon: <Truck />, title: "Free Delivery", desc: "On orders over R500" },
//     { icon: <Shield />, title: "Secure Payment", desc: "100% protected" },
//     { icon: <Award />, title: "Official Warranty", desc: "All products covered" },
//     { icon: <Zap />, title: "Same Day Setup", desc: "Ready to use" }
//   ];

//   const handleAddToCart = async (e, product) => {
//   await addToCart(e, product, fetchUserAddToCart);
// };

//   const handleProductsViews = ()=>{
//     navigate('/landing')
//   }


//   const handleProductsSearch = ()=>{
//     navigate('/product-category')
//   }


//   const renderStars = (rating) => {
//   return [...Array(5)].map((_, i) => (
//     <Star
//       key={i}
//       size={12}
//       fill={i < Math.floor(rating) ? colors.primary : i < rating ? colors.primary : colors.border}
//       style={{ color: i < Math.floor(rating) ? colors.primary : i < rating ? colors.primary : colors.border }}
//     />
//   ));
// }

//   return (
//     <div className="min-h-screen bg-white overflow-hidden relative">
//       {/* Animated Background Elements */}
//       <div className="fixed inset-0 pointer-events-none overflow-hidden">
//         <motion.div
//           className="absolute w-96 h-96 rounded-full blur-3xl opacity-20"
//           style={{
//             background: `radial-gradient(circle, ${colors.primary}, transparent)`,
//             x: useTransform(scrollYProgress, [0, 1], [0, 100]),
//             y: useTransform(scrollYProgress, [0, 1], [0, -100])
//           }}
//         />
//         <motion.div
//           className="absolute right-0 bottom-0 w-96 h-96 rounded-full blur-3xl opacity-20"
//           style={{
//             background: `radial-gradient(circle, ${colors.accent}, transparent)`,
//             x: useTransform(scrollYProgress, [0, 1], [0, -100]),
//             y: useTransform(scrollYProgress, [0, 1], [0, 100])
//           }}
//         />
//       </div>

//       {/* Progress Bar */}
//       <motion.div
//         className="fixed top-0 left-0 right-0 h-1 z-50 origin-left"
//         style={{
//           scaleX: scaleProgress,
//           background: `linear-gradient(90deg, ${colors.primary}, ${colors.accent})`
//         }}
//       />

//       {/* Navigation */}
//       <motion.nav
//         initial={{ y: -100 }}
//         animate={{ y: 0 }}
//         transition={{ duration: 0.6, ease: 'easeOut' }}
//         className={`fixed top-0 w-full z-40 transition-all duration-500 ${
//           scrolled ? 'bg-white/80 backdrop-blur-2xl shadow-xl' : 'bg-transparent'
//         }`}
//         style={{ borderBottom: scrolled ? `1px solid ${colors.border}` : 'none' }}
//       >
//         <div className="max-w-[1400px] mx-auto px-6">
//           <div className="flex justify-between items-center h-16">
//             {/* Logo */}
//             <motion.div
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               className="flex items-center gap-3"
//             >
//               <motion.div
//                 animate={{
//                   rotate: [0, 360],
//                   scale: [1, 1.1, 1]
//                 }}
//                 transition={{
//                   rotate: { duration: 20, repeat: Infinity, ease: 'linear' },
//                   scale: { duration: 2, repeat: Infinity, ease: 'easeInOut' }
//                 }}
//                 className="w-10 h-10 rounded-xl flex items-center justify-center text-white relative"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//               >
//                 <ShoppingBag className="w-6 h-6" />
//                 <motion.div
//                   className="absolute inset-0 rounded-xl"
//                   animate={{
//                     boxShadow: [
//                       `0 0 20px ${colors.primary}50`,
//                       `0 0 40px ${colors.accent}50`,
//                       `0 0 20px ${colors.primary}50`
//                     ]
//                   }}
//                   transition={{ duration: 3, repeat: Infinity }}
//                 />
//               </motion.div>
//               <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                 JosiePhones
//               </span>
//             </motion.div>

//             {/* Center Nav */}
//             <div className="hidden lg:flex items-center gap-8">
//               {['iPhone', 'iPad', 'Mac', 'Watch', 'AirPods', 'Accessories'].map((item, i) => (
//                 <motion.a
//                   key={item}
//                   href="#"
//                   initial={{ opacity: 0, y: -20 }}
//                   animate={{ opacity: 1, y: 0 }}
//                   transition={{ delay: i * 0.1 }}
//                   whileHover={{ y: -2 }}
//                   className="text-sm font-medium relative group"
//                   style={{ color: colors.text }}
//                 >
//                   {item}
//                   <motion.div
//                     className="absolute -bottom-1 left-0 h-0.5 bg-gradient-to-r from-blue-600 to-purple-600"
//                     initial={{ width: 0 }}
//                     whileHover={{ width: '100%' }}
//                     transition={{ duration: 0.3 }}
//                   />
//                 </motion.a>
//               ))}
//             </div>

//             {/* Right Actions */}
//             <div className="flex items-center gap-4">
//               <motion.button
//                 whileHover={{ scale: 1.1, rotate: 90 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.primary }}
//               >
//                 <Search className="w-5 h-5" />
//               </motion.button>
//               <motion.button
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all relative"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.accent }}
//               >
//                 <Heart className="w-5 h-5" />
//                 <motion.span
//                   animate={{ scale: [1, 1.2, 1] }}
//                   transition={{ duration: 2, repeat: Infinity }}
//                   className="absolute -top-1 -right-1 w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white"
//                   style={{ backgroundColor: colors.accent }}
//                 >
//                   3
//                 </motion.span>
//               </motion.button>
//               <motion.button
//                 whileHover={{ scale: 1.1 }}
//                 whileTap={{ scale: 0.9 }}
//                 className="p-2 rounded-xl transition-all relative"
//                 style={{ backgroundColor: colors.bgTertiary, color: colors.primary }}
//               >
//                 <ShoppingCart className="w-5 h-5" />
//                 <motion.span
//                   animate={{ scale: [1, 1.2, 1] }}
//                   transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
//                   className="absolute -top-1 -right-1 w-5 h-5 rounded-full text-xs font-bold flex items-center justify-center text-white"
//                   style={{ backgroundColor: colors.primary }}
//                 >
//                   5
//                 </motion.span>
//               </motion.button>
//             </div>
//           </div>
//         </div>
//       </motion.nav>

//       {/* Hero Section */}
//       <section ref={heroRef} className="relative pt-24 pb-20 min-h-screen flex items-center overflow-hidden">
//         {/* Animated grid background */}
//         <div className="absolute inset-0 opacity-5">
//           <div className="absolute inset-0" style={{
//             backgroundImage: `linear-gradient(${colors.primary} 1px, transparent 1px), linear-gradient(90deg, ${colors.primary} 1px, transparent 1px)`,
//             backgroundSize: '50px 50px'
//           }} />
//         </div>

//         <div className="max-w-[1400px] mx-auto px-6 relative z-10 w-full">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
//             {/* Hero Content */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 1 }}
//             >
//               <motion.div
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 transition={{ duration: 0.6, type: 'spring' }}
//                 className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
//                 style={{ backgroundColor: `${colors.primary}15` }}
//               >
//                 <Sparkles className="w-4 h-4" style={{ color: colors.primary }} />
//                 <span className="text-sm font-bold" style={{ color: colors.primary }}>
//                   New Arrivals Available Now
//                 </span>
//               </motion.div>

//               <h1 className="text-6xl lg:text-7xl font-black mb-6 leading-tight">
//                 <div className="overflow-hidden">
//                   <motion.span
//                     className="hero-title-word inline-block"
//                     style={{ 
//                       background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent'
//                     }}
//                   >
//                     Discover
//                   </motion.span>
//                 </div>
//                 <div className="overflow-hidden">
//                   <motion.span className="hero-title-word inline-block text-gray-900">
//                     The Future
//                   </motion.span>
//                 </div>
//                 <div className="overflow-hidden">
//                   <motion.span className="hero-title-word inline-block text-gray-900">
//                     of Technology
//                   </motion.span>
//                 </div>
//               </h1>

//               <motion.p
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.5, duration: 0.8 }}
//                 className="text-xl mb-8 leading-relaxed"
//                 style={{ color: colors.textSecondary }}
//               >
//                 Experience innovation with our premium collection of cutting-edge devices. 
//                 Buy it easily at JosiePhones!
//               </motion.p>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.7, duration: 0.8 }}
//                 className="flex flex-wrap gap-4"
//               >
//                 <motion.button
//                   whileHover={{ scale: 1.05, boxShadow: `0 20px 40px ${colors.primary}30` }}
//                   whileTap={{ scale: 0.95 }}
//                   className="px-8 py-4 rounded-2xl font-bold text-white flex items-center gap-2 relative overflow-hidden group"
//                   style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                   onClick={handleProductsSearch}
//                 >
//                   <span 
//                     className="relative z-10"
                    
//                   >
//                     Shop Now
//                   </span>
//                   <ArrowRight className="w-5 h-5 relative z-10 group-hover:translate-x-1 transition-transform" />
//                   <motion.div
//                     className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20"
//                     initial={{ x: '-100%' }}
//                     whileHover={{ x: '100%' }}
//                     transition={{ duration: 0.6 }}
//                   />
//                 </motion.button>

//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="px-8 py-4 rounded-2xl font-bold border-2 flex items-center gap-2"
//                   style={{ 
//                     borderColor: colors.primary,
//                     color: colors.primary
//                   }}
//                 >
//                   <Sparkles className="w-5 h-5" />
//                   Explore Products
//                 </motion.button>
//               </motion.div>

//               {/* Stats */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.9, duration: 0.8 }}
//                 className="grid grid-cols-3 gap-6 mt-12"
//               >
//                 {[
//                   { value: '50K+', label: 'Happy Customers' },
//                   { value: '1000+', label: 'Products' },
//                   { value: '4.9', label: 'Rating' }
//                 ].map((stat, i) => (
//                   <motion.div
//                     key={i}
//                     whileHover={{ y: -5 }}
//                     className="text-center"
//                   >
//                     <motion.div
//                       initial={{ scale: 0 }}
//                       animate={{ scale: 1 }}
//                       transition={{ delay: 1 + i * 0.1, type: 'spring' }}
//                       className="text-3xl font-black mb-1"
//                       style={{ 
//                         background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})`,
//                         WebkitBackgroundClip: 'text',
//                         WebkitTextFillColor: 'transparent'
//                       }}
//                     >
//                       {stat.value}
//                     </motion.div>
//                     <div className="text-sm" style={{ color: colors.textSecondary }}>
//                       {stat.label}
//                     </div>
//                   </motion.div>
//                 ))}
//               </motion.div>
//             </motion.div>

//             {/* Hero Images - 3D Stack */}
//             <div className="relative h-[600px]">
//               {heroProducts.map((product, i) => (
//                 <motion.div
//                   key={product.id}
//                   className="floating-element absolute parallax-img"
//                   initial={{ opacity: 0, scale: 0, rotateY: 180 }}
//                   animate={{ 
//                     opacity: 1, 
//                     scale: 1, 
//                     rotateY: 0,
//                     x: [0, i * 20, 0],
//                     y: [0, -i * 15, 0]
//                   }}
//                   transition={{ 
//                     delay: 0.2 * i, 
//                     duration: 1,
//                     x: { duration: 3, repeat: Infinity, ease: 'easeInOut' },
//                     y: { duration: 2.5, repeat: Infinity, ease: 'easeInOut', delay: i * 0.2 }
//                   }}
//                   whileHover={{ 
//                     scale: 1.1, 
//                     zIndex: 50,
//                     rotateY: 10,
//                     transition: { duration: 0.3 }
//                   }}
//                   style={{
//                     top: `${i * 80}px`,
//                     left: `${i * 60}px`,
//                     zIndex: 10 - i
//                   }}
//                   // className="w-80 h-96 rounded-3xl overflow-hidden cursor-pointer group"
//                 >
//                   <div className="relative w-full h-full">
//                     <img
//                       src={product.image}
//                       alt={product.name}
//                       className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                     />
//                     <div 
//                       className="absolute inset-0 opacity-80 group-hover:opacity-90 transition-opacity"
//                       style={{ background: `linear-gradient(135deg, transparent, ${product.color.split(' ')[1]} 100%)` }}
//                     />
//                     <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
//                       <motion.span
//                         initial={{ scale: 0 }}
//                         animate={{ scale: 1 }}
//                         className="inline-block px-3 py-1 rounded-full text-xs font-bold mb-3 w-fit"
//                         style={{ backgroundColor: 'rgba(255,255,255,0.3)', backdropFilter: 'blur(10px)' }}
//                       >
//                         {product.badge}
//                       </motion.span>
//                       <h3 className="text-2xl font-bold mb-2">{product.name}</h3>
//                       <p className="text-sm opacity-90 mb-2">{product.tagline}</p>
//                       <p className="text-3xl font-black">{product.price}</p>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Scroll Indicator */}
//         <motion.div
//           animate={{ y: [0, 10, 0] }}
//           transition={{ duration: 2, repeat: Infinity }}
//           className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
//         >
//           <ChevronRight className="w-6 h-6 rotate-90" style={{ color: colors.primary }} />
//         </motion.div>
//       </section>

//       {/* Features Bar */}
//       <section className="py-8" style={{ backgroundColor: colors.bgSecondary }}>
//         <div className="max-w-[1400px] mx-auto px-6">
//           <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
//             {features.map((feature, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 whileHover={{ y: -5 }}
//                 className="flex items-center gap-3 p-4 rounded-2xl"
//                 style={{ backgroundColor: colors.bg }}
//               >
//                 <div 
//                   className="p-3 rounded-xl"
//                   style={{ backgroundColor: `${colors.primary}15`, color: colors.primary }}
//                 >
//                   {feature.icon}
//                 </div>
//                 <div>
//                   <div className="font-bold text-sm" style={{ color: colors.text }}>
//                     {feature.title}
//                   </div>
//                   <div className="text-xs" style={{ color: colors.textSecondary }}>
//                     {feature.desc}
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Featured Products */}
// <section ref={productsRef} className="py-24">
//   <div className="max-w-[1400px] mx-auto px-6">
//     <motion.div
//       initial={{ opacity: 0, y: 30 }}
//       whileInView={{ opacity: 1, y: 0 }}
//       viewport={{ once: true }}
//       className="text-center mb-16"
//     >
//       <motion.div
//         initial={{ scale: 0 }}
//         whileInView={{ scale: 1 }}
//         viewport={{ once: true }}
//         className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4"
//         style={{ backgroundColor: `${colors.accent}15` }}
//       >
//         <Star className="w-4 h-4" style={{ color: colors.accent }} />
//         <span className="text-sm font-bold" style={{ color: colors.accent }}>
//           Trending Now
//         </span>
//       </motion.div>
//       <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//         Featured Products
//       </h2>
//       <p className="text-xl max-w-2xl mx-auto" style={{ color: colors.textSecondary }}>
//         Discover our handpicked selection of premium devices
//       </p>
//     </motion.div>

//     {/* Loading State */}
//     {loadingProducts && (
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//         {Array.from({ length: 6 }).map((_, i) => (
//           <div
//             key={i}
//             className="rounded-3xl overflow-hidden animate-pulse"
//             style={{ backgroundColor: colors.bgSecondary }}
//           >
//             <div className="h-80" style={{ backgroundColor: colors.bgTertiary }} />
//             <div className="p-6 space-y-4">
//               <div className="h-4 rounded-full w-3/4" style={{ backgroundColor: colors.bgTertiary }} />
//               <div className="h-6 rounded-full w-1/2" style={{ backgroundColor: colors.bgTertiary }} />
//               <div className="h-8 rounded-full w-2/3" style={{ backgroundColor: colors.bgTertiary }} />
//             </div>
//           </div>
//         ))}
//       </div>
//     )}

//     {/* Featured Products Grid */}
// {!loadingProducts && (
//   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//     {featuredProducts.slice(0, 6).map((product, i) => (
//       <motion.div
//         key={product._id}
//         className="product-reveal group cursor-pointer"
//         whileHover={{ y: -10 }}
//         transition={{ type: 'spring', stiffness: 300 }}
//       >
//         <div className="relative rounded-3xl overflow-hidden" style={{ backgroundColor: colors.bgSecondary }}>
//           {/* Product Image */}
//           <div className="relative h-80 overflow-hidden">
//             <motion.img
//               src={product.productImage?.[0]}
//               alt={product.productName}
//               className="w-full h-full object-cover"
//               whileHover={{ scale: 1.15, rotate: 2 }}
//               transition={{ duration: 0.6 }}
//             />
//             <motion.div
//               className="absolute inset-0"
//               initial={{ opacity: 0 }}
//               whileHover={{ opacity: 1 }}
//               style={{ background: `linear-gradient(135deg, transparent, ${colors.primary}40)` }}
//             />
            
//             {/* Badge - Use featured status */}
//             {product.featured && (
//               <motion.div
//                 initial={{ scale: 0, rotate: -180 }}
//                 animate={{ scale: 1, rotate: 0 }}
//                 transition={{ delay: i * 0.1 + 0.3 }}
//                 className="absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold text-white"
//                 style={{ backgroundColor: colors.accent }}
//               >
//                 FEATURED
//               </motion.div>
//             )}

//             {/* Discount Badge */}
//             {product.productDiscount && product.productPrice && (
//               <motion.div
//                 initial={{ scale: 0, rotate: -180 }}
//                 animate={{ scale: 1, rotate: 0 }}
//                 transition={{ delay: i * 0.1 + 0.3 }}
//                 className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold text-white"
//                 style={{ backgroundColor: colors.accent }}
//               >
//                 -{Math.round((product.productDiscount / product.productPrice) * 100)}%
//               </motion.div>
//             )}

//             {/* REAL Like Button (replacing the heart icon) */}
//             <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-all duration-300 z-20 pointer-events-auto">
//               <LikeButton productId={product._id} size={20} />
//             </div>

//             {/* Hover Overlay with View Details Button */}
//             <motion.div
//               className="absolute inset-0 flex items-center justify-center"
//               initial={{ opacity: 0 }}
//               whileHover={{ opacity: 1 }}
//               style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}
//             >
//               <motion.button
//                 initial={{ y: 20 }}
//                 whileHover={{ y: 0 }}
//                 className="px-6 py-3 rounded-full font-bold text-white flex items-center gap-2"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                 onClick={() => navigate(`/product/${product._id}`)}
//               >
//                 <Eye size={16} />
//                 View Details
//               </motion.button>
//             </motion.div>
//           </div>

//           {/* Product Info */}
//           <div className="p-6">
//             <div className="flex items-center justify-between mb-3">
//               <span className="text-sm font-bold" style={{ color: colors.primary }}>
//                 {product.productsCategory}
//               </span>
              
//               {/* REAL Rating Section */}
//               <div className="flex items-center gap-1">
//                 <div className="flex gap-0.5">
//                   {productRatings[product._id] ? (
//                     renderStars(productRatings[product._id].average)
//                   ) : (
//                     [...Array(5)].map((_, i) => (
//                       <Star key={i} size={12} style={{ color: colors.border }} />
//                     ))
//                   )}
//                 </div>
//                 <span className="text-xs ml-1" style={{ color: colors.textSecondary }}>
//                   {productRatings[product._id] ? (
//                     `(${productRatings[product._id].average.toFixed(1)})`
//                   ) : (
//                     '(No reviews)'
//                   )}
//                 </span>
//               </div>
//             </div>
            
//             <h3 className="text-xl font-bold mb-3" style={{ color: colors.text }}>
//               {product.productName}
//             </h3>

//             <div className="flex items-center justify-between">
//               <div>
//                 <div className="text-3xl font-black" style={{ color: colors.text }}>
//                   ₦{product.productPrice?.toLocaleString()}
//                 </div>
//                 {/* {product.productDiscount > 0 && (
//                   <div className="text-sm line-through" style={{ color: colors.textSecondary }}>
//                     ₦{(parseFloat(product.productPrice) + parseFloat(product.productDiscount)).toLocaleString()}
//                   </div>
//                 )} */}
//               </div>
              
//               {/* Add to Cart Button */}
//               <motion.button
//                 whileHover={{ scale: 1.1, rotate: 360 }}
//                 whileTap={{ scale: 0.9 }}
//                 transition={{ rotate: { duration: 0.5 } }}
//                 className="w-12 h-12 rounded-full flex items-center justify-center text-white"
//                 style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleAddToCart(e, product);
//                 }}
//               >
//                 <ShoppingCart className="w-5 h-5" />
//               </motion.button>
//             </div>
//           </div>
//         </div>
//       </motion.div>
//     ))}
//   </div>
// )}

//     {/* Empty State */}
//     {!loadingProducts && featuredProducts.length === 0 && (
//       <div className="text-center py-12">
//         <Package className="w-16 h-16 mx-auto mb-4" style={{ color: colors.textSecondary }} />
//         <p className="text-xl" style={{ color: colors.textSecondary }}>No featured products available</p>
//       </div>
//     )}

//     {/* View All Button */}
//     <motion.div
//       initial={{ opacity: 0, scale: 0.8 }}
//       whileInView={{ opacity: 1, scale: 1 }}
//       viewport={{ once: true }}
//       className="text-center mt-12"
//     >
//       <motion.button
//         whileHover={{ scale: 1.05, boxShadow: `0 20px 40px ${colors.primary}30` }}
//         whileTap={{ scale: 0.95 }}
//         className="px-10 py-4 rounded-2xl font-bold text-white flex items-center gap-2 mx-auto"
//         style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//         onClick={handleProductsViews}
//       >
//         View All Products
//         <TrendingUp className="w-5 h-5" />
//       </motion.button>
//     </motion.div>
//   </div>
// </section>

//       {/* Services Section */}
//       <section ref={servicesRef} className="py-24" style={{ backgroundColor: colors.bgSecondary }}>
//         <div className="max-w-[1400px] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <motion.div
//               initial={{ scale: 0 }}
//               whileInView={{ scale: 1 }}
//               viewport={{ once: true }}
//               className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4"
//               style={{ backgroundColor: `${colors.success}15` }}
//             >
//               <CheckCircle2 className="w-4 h-4" style={{ color: colors.success }} />
//               <span className="text-sm font-bold" style={{ color: colors.success }}>
//                 Premium Services
//               </span>
//             </motion.div>
//             <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//               Why Shop With Us
//             </h2>
//             <p className="text-xl max-w-2xl mx-auto" style={{ color: colors.textSecondary }}>
//               Experience unmatched service and support at every step
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-2 gap-6">
//             {services.map((service, i) => (
//               <motion.div
//                 key={i}
//                 className="service-card group cursor-pointer"
//                 whileHover={{ scale: 1.02 }}
//                 transition={{ type: 'spring', stiffness: 300 }}
//               >
//                 <div 
//                   className="rounded-3xl p-8 md:p-10 min-h-[350px] flex flex-col justify-between text-white relative overflow-hidden"
//                   style={{ background: service.gradient }}
//                 >
//                   {/* Animated background circles */}
//                   <motion.div
//                     className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10"
//                     animate={{
//                       scale: [1, 1.2, 1],
//                       rotate: [0, 180, 360]
//                     }}
//                     transition={{ duration: 20, repeat: Infinity }}
//                   />
//                   <motion.div
//                     className="absolute -left-10 -bottom-10 w-32 h-32 rounded-full bg-white/10"
//                     animate={{
//                       scale: [1, 1.3, 1],
//                       rotate: [0, -180, -360]
//                     }}
//                     transition={{ duration: 15, repeat: Infinity }}
//                   />

//                   <div className="relative z-10">
//                     <motion.div
//                       whileHover={{ rotate: 360, scale: 1.2 }}
//                       transition={{ duration: 0.6 }}
//                       className="mb-6 inline-block"
//                     >
//                       {service.icon}
//                     </motion.div>
                    
//                     <div className="text-xs font-bold tracking-wider mb-3 opacity-90">
//                       {service.label}
//                     </div>
                    
//                     <h3 className="text-3xl font-black mb-3 leading-tight">
//                       {service.title}
//                     </h3>
                    
//                     <p className="text-base opacity-90 leading-relaxed mb-4">
//                       {service.description}
//                     </p>

//                     <motion.div
//                       initial={{ width: 0 }}
//                       whileInView={{ width: '80px' }}
//                       viewport={{ once: true }}
//                       transition={{ delay: i * 0.2 }}
//                       className="h-1 bg-white rounded-full mb-4"
//                     />

//                     <div className="text-2xl font-black">
//                       {service.stats}
//                     </div>
//                   </div>

//                   <motion.button
//                     whileHover={{ x: 10 }}
//                     className="relative z-10 text-white font-bold flex items-center gap-2 mt-6 group-hover:gap-4 transition-all"
//                   >
//                     Learn More
//                     <ArrowRight className="w-5 h-5" />
//                   </motion.button>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Testimonials Section */}
//       <section className="py-24">
//         <div className="max-w-[1400px] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-5xl font-black mb-4" style={{ color: colors.text }}>
//               What Our Customers Say
//             </h2>
//             <p className="text-xl" style={{ color: colors.textSecondary }}>
//               Join thousands of satisfied customers
//             </p>
//           </motion.div>

//           <div className="grid md:grid-cols-3 gap-6">
//             {[1, 2, 3].map((item, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.2 }}
//                 whileHover={{ y: -10, boxShadow: `0 20px 40px ${colors.primary}20` }}
//                 className="p-8 rounded-3xl relative"
//                 style={{ backgroundColor: colors.bg, border: `1px solid ${colors.border}` }}
//               >
//                 <div className="flex gap-1 mb-4">
//                   {[1, 2, 3, 4, 5].map((star) => (
//                     <motion.div
//                       key={star}
//                       initial={{ scale: 0, rotate: -180 }}
//                       whileInView={{ scale: 1, rotate: 0 }}
//                       viewport={{ once: true }}
//                       transition={{ delay: i * 0.2 + star * 0.1 }}
//                     >
//                       <Star className="w-5 h-5 fill-current" style={{ color: colors.warning }} />
//                     </motion.div>
//                   ))}
//                 </div>
                
//                 <p className="text-lg mb-6 leading-relaxed" style={{ color: colors.text }}>
//                   "Absolutely amazing experience! The quality and service exceeded all expectations. Highly recommend!"
//                 </p>

//                 <div className="flex items-center gap-3">
//                   <motion.div
//                     whileHover={{ scale: 1.1, rotate: 360 }}
//                     transition={{ duration: 0.6 }}
//                     className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
//                     style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//                   >
//                     {String.fromCharCode(65 + i)}
//                   </motion.div>
//                   <div>
//                     <div className="font-bold" style={{ color: colors.text }}>
//                       Customer {i + 1}
//                     </div>
//                     <div className="text-sm" style={{ color: colors.textSecondary }}>
//                       Verified Buyer
//                     </div>
//                   </div>
//                 </div>

//                 <motion.div
//                   className="absolute top-6 right-6 opacity-10"
//                   animate={{ rotate: 360 }}
//                   transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
//                 >
//                   <Gift className="w-16 h-16" style={{ color: colors.primary }} />
//                 </motion.div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-24 relative overflow-hidden">
//         <motion.div
//           className="absolute inset-0"
//           style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.accent})` }}
//         />
        
//         {/* Animated background elements */}
//         <motion.div
//           className="absolute top-0 left-0 w-64 h-64 rounded-full bg-white/10"
//           animate={{
//             scale: [1, 1.5, 1],
//             x: [0, 100, 0],
//             y: [0, 50, 0]
//           }}
//           transition={{ duration: 10, repeat: Infinity }}
//         />
//         <motion.div
//           className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white/10"
//           animate={{
//             scale: [1, 1.3, 1],
//             x: [0, -100, 0],
//             y: [0, -50, 0]
//           }}
//           transition={{ duration: 15, repeat: Infinity }}
//         />

//         <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             viewport={{ once: true }}
//             className="mb-8"
//           >
//             <motion.div
//               animate={{ rotate: 360 }}
//               transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
//               className="w-20 h-20 mx-auto mb-6 rounded-full bg-white/20 flex items-center justify-center"
//             >
//               <Sparkles className="w-10 h-10 text-white" />
//             </motion.div>

//             <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
//               Ready to Upgrade?
//             </h2>
//             <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
//               Join thousands of satisfied customers and experience the future of technology today with JosiePhones!
//             </p>
//           </motion.div>

//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <motion.button
//               whileHover={{ scale: 1.05, y: -5 }}
//               whileTap={{ scale: 0.95 }}
//               className="px-10 py-5 rounded-2xl font-bold bg-white flex items-center justify-center gap-2 shadow-2xl"
//               style={{ color: colors.primary }}
//             >
//               Start Shopping
//               <ShoppingBag className="w-5 h-5" />
//             </motion.button>
            
//             <motion.button
//               whileHover={{ scale: 1.05, y: -5 }}
//               whileTap={{ scale: 0.95 }}
//               className="px-10 py-5 rounded-2xl font-bold border-2 border-white text-white hover:bg-white/10 transition-colors"
//             >
//               Contact Us
//             </motion.button>
//           </div>

//           {/* Trust badges */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mt-12 flex flex-wrap justify-center gap-6"
//           >
//             {['Secure Payment', 'Free Delivery', '2-Year Warranty', '24/7 Support'].map((badge, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, scale: 0 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/20 backdrop-blur-sm"
//               >
//                 <CheckCircle2 className="w-4 h-4 text-white" />
//                 <span className="text-sm text-white font-medium">{badge}</span>
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>
     
//     </div>
//   );
// };

// export default Home;


// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { 
//   ShoppingBag, 
//   Shield, 
//   Truck, 
//   ArrowRight,
//   Star,
//   Search,
//   ShoppingCart,
//   ChevronDown,
//   Award,
//   Eye,
//   User
// } from 'lucide-react';
// import { useTheme } from 'components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import addToCart from 'helpers/addToCart';
// import Context from "../../context";
// import LikeButton from '../../components/ProductLike/LikeButton'; 
// import { summaryApi } from "../../common"; 

// gsap.registerPlugin(ScrollTrigger);

// const Home = () => {
//   const { colors } = useTheme();
//   const { fetchUserAddToCart } = useContext(Context);
//   const [scrolled, setScrolled] = useState(false);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [productRatings, setProductRatings] = useState({});
//   const heroRef = useRef(null);
//   const productsRef = useRef(null);
//   const navigate = useNavigate();

//   const { scrollYProgress } = useScroll();

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     // Smooth fade-in animations
//     gsap.fromTo('.fade-in-section',
//       { opacity: 0, y: 60 },
//       {
//         opacity: 1,
//         y: 0,
//         duration: 1,
//         stagger: 0.2,
//         ease: 'power3.out',
//         scrollTrigger: {
//           trigger: '.fade-in-section',
//           start: 'top 80%'
//         }
//       }
//     );
//   }, []);

//   const fetchProductRating = async (productId) => {
//     try {
//       const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
//         method: summaryApi.getReviews.method,
//         credentials: 'include'
//       });
//       const data = await response.json();
      
//       if (data.data && data.data.length > 0) {
//         const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
//         const averageRating = totalRating / data.data.length;
        
//         setProductRatings(prev => ({
//           ...prev,
//           [productId]: {
//             average: averageRating,
//             count: data.data.length
//           }
//         }));
//       }
//     } catch (error) {
//       console.error(`Error fetching rating for product ${productId}:`, error);
//     }
//   };

//   useEffect(() => {
//     const fetchFeaturedProducts = async () => {
//       try {
//         setLoadingProducts(true);
//         const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//         const response = await fetch(`${backendUrl}/api/product/featured-products`);
//         const data = await response.json();
        
//         if (data.success && data.data) {
//           setFeaturedProducts(data.data);
//           data.data.forEach(product => {
//             fetchProductRating(product._id);
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching featured products:', error);
//       } finally {
//         setLoadingProducts(false);
//       }
//     };

//     fetchFeaturedProducts();
//   }, []);

//   const handleAddToCart = async (e, product) => {
//     await addToCart(e, product, fetchUserAddToCart);
//   };

//   const renderStars = (rating) => {
//     return [...Array(5)].map((_, i) => (
//       <Star
//         key={i}
//         size={14}
//         fill={i < Math.floor(rating) ? '#000' : 'none'}
//         className={i < Math.floor(rating) ? 'text-black' : 'text-gray-300'}
//       />
//     ));
//   };

//   return (
//     <div className="min-h-screen bg-white overflow-hidden">
//       {/* Apple-style Nav Bar */}
      

//       {/* Hero Section - Apple Style */}
//       <section ref={heroRef} className="relative pt-12 bg-black text-white overflow-hidden">
//         <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8 }}
//           >
//             <h1 className="text-5xl md:text-7xl font-semibold mb-4 tracking-tight">
//               iPhone 15 Pro
//             </h1>
//             <p className="text-2xl md:text-3xl text-gray-400 mb-6">
//               Titanium. So strong. So light. So Pro.
//             </p>
//             <div className="flex gap-6 justify-center text-lg mb-8">
//               <button 
//                 onClick={() => navigate('/landing')}
//                 className="text-blue-500 hover:underline"
//               >
//                 Learn more
//               </button>
//               <button 
//                 onClick={() => navigate('/product-category')}
//                 className="text-blue-500 hover:underline"
//               >
//                 Buy
//               </button>
//             </div>
//           </motion.div>
//         </div>
        
//         {/* Hero Image */}
//         <div className="w-full h-[600px] relative">
//           <img 
//             src="https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=1600&q=90"
//             alt="iPhone 15 Pro"
//             className="w-full h-full object-cover"
//           />
//         </div>

//         {/* Scroll Indicator */}
//         <motion.div
//           animate={{ y: [0, 12, 0] }}
//           transition={{ duration: 1.5, repeat: Infinity }}
//           className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white"
//         >
//           <ChevronDown size={24} />
//         </motion.div>
//       </section>

//       {/* Secondary Hero - MacBook */}
//       <section className="relative bg-gray-50 overflow-hidden">
//         <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.8 }}
//           >
//             <h2 className="text-4xl md:text-6xl font-semibold mb-3 text-gray-900">
//               MacBook Air 15″
//             </h2>
//             <p className="text-xl md:text-2xl text-gray-600 mb-6">
//               Impressively big. Impossibly thin.
//             </p>
//             <div className="flex gap-6 justify-center text-base">
//               <button 
//                 onClick={() => navigate('/landing')}
//                 className="text-blue-600 hover:underline"
//               >
//                 Learn more
//               </button>
//               <button 
//                 onClick={() => navigate('/product-category')}
//                 className="text-blue-600 hover:underline"
//               >
//                 Buy
//               </button>
//             </div>
//           </motion.div>
//         </div>
        
//         <div className="w-full h-[500px] relative">
//           <img 
//             src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=1600&q=90"
//             alt="MacBook Air"
//             className="w-full h-full object-contain"
//           />
//         </div>
//       </section>

//       {/* Two-Column Promos */}
//       <div className="max-w-[1400px] mx-auto px-4 py-4 grid md:grid-cols-2 gap-4">
//         {/* Apple Watch */}
//         <section className="relative bg-black text-white rounded-3xl overflow-hidden">
//           <div className="text-center py-12 px-6">
//             <div className="mb-3">
//               <span className="text-orange-500 text-lg font-semibold">WATCH</span>
//             </div>
//             <h3 className="text-3xl md:text-5xl font-semibold mb-2">
//               Series 9
//             </h3>
//             <p className="text-lg text-gray-400 mb-6">
//               Smarter. Brighter. Mightier.
//             </p>
//             <div className="flex gap-6 justify-center text-base">
//               <button 
//                 onClick={() => navigate('/landing')}
//                 className="text-blue-500 hover:underline"
//               >
//                 Learn more
//               </button>
//               <button 
//                 onClick={() => navigate('/product-category')}
//                 className="text-blue-500 hover:underline"
//               >
//                 Buy
//               </button>
//             </div>
//           </div>
//           <div className="h-[300px] relative">
//             <img 
//               src="https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=800&q=80"
//               alt="Apple Watch"
//               className="w-full h-full object-cover"
//             />
//           </div>
//         </section>

//         {/* iPad */}
//         <section className="relative bg-gray-100 rounded-3xl overflow-hidden">
//           <div className="text-center py-12 px-6">
//             <h3 className="text-3xl md:text-5xl font-semibold mb-2 text-gray-900">
//               iPad Pro
//             </h3>
//             <p className="text-lg text-gray-600 mb-6">
//               Supercharged by M2.
//             </p>
//             <div className="flex gap-6 justify-center text-base">
//               <button 
//                 onClick={() => navigate('/landing')}
//                 className="text-blue-600 hover:underline"
//               >
//                 Learn more
//               </button>
//               <button 
//                 onClick={() => navigate('/product-category')}
//                 className="text-blue-600 hover:underline"
//               >
//                 Buy
//               </button>
//             </div>
//           </div>
//           <div className="h-[300px] relative">
//             <img 
//               src="https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=800&q=80"
//               alt="iPad Pro"
//               className="w-full h-full object-contain"
//             />
//           </div>
//         </section>
//       </div>

//       {/* Featured Products Section */}
//       <section ref={productsRef} className="py-20 bg-white fade-in-section">
//         <div className="max-w-[1200px] mx-auto px-6">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-gray-900">
//               Featured Products
//             </h2>
//             <p className="text-xl text-gray-600">
//               Discover our handpicked collection
//             </p>
//           </div>

//           {/* Loading State */}
//           {loadingProducts && (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {Array.from({ length: 6 }).map((_, i) => (
//                 <div key={i} className="animate-pulse">
//                   <div className="bg-gray-200 h-80 rounded-2xl mb-4" />
//                   <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
//                   <div className="h-6 bg-gray-200 rounded w-1/2" />
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Products Grid */}
//           {!loadingProducts && (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {featuredProducts.slice(0, 6).map((product, i) => (
//                 <motion.div
//                   key={product._id}
//                   initial={{ opacity: 0, y: 40 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.1, duration: 0.6 }}
//                   className="group cursor-pointer"
//                 >
//                   <div className="relative rounded-2xl overflow-hidden bg-gray-50 mb-4">
//                     {/* Product Image */}
//                     <div className="relative h-80 overflow-hidden">
//                       <img
//                         src={product.productImage?.[0]}
//                         alt={product.productName}
//                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                       />
                      
//                       {/* Featured Badge */}
//                       {product.featured && (
//                         <div className="absolute top-4 right-4 px-3 py-1 bg-black text-white text-xs font-semibold rounded-full">
//                           FEATURED
//                         </div>
//                       )}

//                       {/* Discount Badge */}
//                       {product.productDiscount && product.productPrice && (
//                         <div className="absolute top-4 left-4 px-3 py-1 bg-red-500 text-white text-xs font-semibold rounded-full">
//                           -{Math.round((product.productDiscount / product.productPrice) * 100)}% OFF
//                         </div>
//                       )}

//                       {/* Like Button */}
//                       <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                         <LikeButton productId={product._id} size={20} />
//                       </div>

//                       {/* Quick View Overlay */}
//                       <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
//                         <button
//                           onClick={() => navigate(`/product/${product._id}`)}
//                           className="px-6 py-3 bg-white text-black rounded-full font-semibold flex items-center gap-2 hover:bg-gray-100 transition"
//                         >
//                           <Eye size={16} />
//                           Quick View
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Product Info */}
//                   <div className="px-2">
//                     <div className="flex items-center justify-between mb-2">
//                       <span className="text-xs font-semibold text-orange-600 uppercase">
//                         {product.productsCategory}
//                       </span>
                      
//                       {/* Rating */}
//                       <div className="flex items-center gap-1">
//                         {productRatings[product._id] ? (
//                           <>
//                             {renderStars(productRatings[product._id].average)}
//                             <span className="text-xs text-gray-600 ml-1">
//                               ({productRatings[product._id].average.toFixed(1)})
//                             </span>
//                           </>
//                         ) : (
//                           <span className="text-xs text-gray-400">No reviews</span>
//                         )}
//                       </div>
//                     </div>
                    
//                     <h3 className="text-lg font-semibold mb-2 text-gray-900 line-clamp-2">
//                       {product.productName}
//                     </h3>

//                     <div className="flex items-center justify-between">
//                       <div>
//                         <div className="text-2xl font-semibold text-gray-900">
//                           ₦{product.productPrice?.toLocaleString()}
//                         </div>
//                       </div>
                      
//                       {/* Add to Cart */}
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleAddToCart(e, product);
//                         }}
//                         className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center hover:bg-blue-700 transition"
//                       >
//                         <ShoppingCart size={18} />
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}

//           {/* View All Button */}
//           <div className="text-center mt-12">
//             <button
//               onClick={() => navigate('/landing')}
//               className="px-8 py-4 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition inline-flex items-center gap-2"
//             >
//               View All Products
//               <ArrowRight size={18} />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Services Section - Apple Style */}
//       <section className="py-20 bg-gray-50 fade-in-section">
//         <div className="max-w-[1200px] mx-auto px-6">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-gray-900">
//               Why Shop With Us
//             </h2>
//             <p className="text-xl text-gray-600">
//               Premium service at every step
//             </p>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8">
//             {[
//               {
//                 icon: <Truck size={40} />,
//                 title: 'Fast, free delivery',
//                 desc: 'Free delivery on all orders over ₦5,000'
//               },
//               {
//                 icon: <Shield size={40} />,
//                 title: 'Extended warranty',
//                 desc: 'Get AppleCare+ for complete peace of mind'
//               },
//               {
//                 icon: <Award size={40} />,
//                 title: 'Expert support',
//                 desc: 'Get help from our Specialists anytime'
//               }
//             ].map((service, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.15, duration: 0.6 }}
//                 className="text-center p-8"
//               >
//                 <div className="text-gray-900 mb-4 flex justify-center">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-semibold mb-2 text-gray-900">
//                   {service.title}
//                 </h3>
//                 <p className="text-gray-600">
//                   {service.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Footer - Apple Style */}
//       <footer className="bg-gray-50 py-12 border-t border-gray-200">
//         <div className="max-w-[980px] mx-auto px-6">
//           <div className="text-center mb-8">
//             <p className="text-sm text-gray-600 mb-4">
//               More ways to shop: Find an Apple Store or other retailer near you. Or call 1-800-MY-APPLE.
//             </p>
//             <div className="flex justify-center gap-4 text-xs text-gray-600">
//               <a href="#" className="hover:underline">Privacy Policy</a>
//               <span>|</span>
//               <a href="#" className="hover:underline">Terms of Use</a>
//               <span>|</span>
//               <a href="#" className="hover:underline">Sales and Refunds</a>
//             </div>
//           </div>
//           <p className="text-center text-xs text-gray-500">
//             Copyright © 2024 JosiePhones Inc. All rights reserved.
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Home;





// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { motion, useScroll } from 'framer-motion';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { 
//   ShoppingCart, 
//   ChevronDown,
//   Award,
//   Eye,
//   Star,
//   Truck,
//   Shield,
//   ArrowRight
// } from 'lucide-react';
// import { useTheme } from 'components/Theme/ThemeProvider';
// import { useNavigate } from 'react-router-dom';
// import addToCart from 'helpers/addToCart';
// import Context from "../../context";
// import LikeButton from '../../components/ProductLike/LikeButton'; 
// import { summaryApi } from "../../common"; 

// gsap.registerPlugin(ScrollTrigger);

// const Home = () => {
//   const { colors } = useTheme();
//   const { fetchUserAddToCart } = useContext(Context);
//   const [scrolled, setScrolled] = useState(false);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [productRatings, setProductRatings] = useState({});
//   const [banners, setBanners] = useState({
//     hero: null,
//     basic: null,
//     promotional: null,
//     featured: null
//   });
//   const [loadingBanners, setLoadingBanners] = useState(true);
//   const heroRef = useRef(null);
//   const productsRef = useRef(null);
//   const navigate = useNavigate();

//   const { scrollYProgress } = useScroll();

//   // Handle scroll
//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Fetch banners
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         setLoadingBanners(true);
//         const response = await fetch(summaryApi.getBanners.url, {
//           method: summaryApi.getBanners.method
//         });
//         const data = await response.json();
        
//         if (data.success && data.banners) {
//           const organizedBanners = {
//             hero: data.banners.find(b => b.section === 'hero' && b.isActive),
//             basic: data.banners.find(b => b.section === 'basic' && b.isActive),
//             promotional: data.banners.find(b => b.section === 'promotional' && b.isActive),
//             featured: data.banners.find(b => b.section === 'featured' && b.isActive),
//             footer: data.banners.find(b => b.section === 'footer' && b.isActive),
//             header: data.banners.find(b => b.section === 'header' && b.isActive),
//             sidebar: data.banners.find(b => b.section === 'sidebar' && b.isActive),
//             mid_page: data.banners.find(b => b.section === 'mid_page' && b.isActive)
//           };
//           setBanners(organizedBanners);
//         }
//       } catch (error) {
//         console.error('Error fetching banners:', error);
//       } finally {
//         setLoadingBanners(false);
//       }
//     };

//     fetchBanners();
//   }, []);

//   // GSAP animations
//   useEffect(() => {
//     gsap.fromTo('.fade-in-section',
//       { opacity: 0, y: 60 },
//       {
//         opacity: 1,
//         y: 0,
//         duration: 1,
//         stagger: 0.2,
//         ease: 'power3.out',
//         scrollTrigger: {
//           trigger: '.fade-in-section',
//           start: 'top 80%'
//         }
//       }
//     );
//   }, []);

//   // Fetch product ratings
//   const fetchProductRating = async (productId) => {
//     try {
//       const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
//         method: summaryApi.getReviews.method,
//         credentials: 'include'
//       });
//       const data = await response.json();
      
//       if (data.data && data.data.length > 0) {
//         const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
//         const averageRating = totalRating / data.data.length;
        
//         setProductRatings(prev => ({
//           ...prev,
//           [productId]: {
//             average: averageRating,
//             count: data.data.length
//           }
//         }));
//       }
//     } catch (error) {
//       console.error(`Error fetching rating for product ${productId}:`, error);
//     }
//   };

//   // Fetch featured products
//   useEffect(() => {
//     const fetchFeaturedProducts = async () => {
//       try {
//         setLoadingProducts(true);
//         const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//         const response = await fetch(`${backendUrl}/api/product/featured-products`);
//         const data = await response.json();
        
//         if (data.success && data.data) {
//           setFeaturedProducts(data.data);
//           data.data.forEach(product => {
//             fetchProductRating(product._id);
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching featured products:', error);
//       } finally {
//         setLoadingProducts(false);
//       }
//     };

//     fetchFeaturedProducts();
//   }, []);

//   const handleAddToCart = async (e, product) => {
//     await addToCart(e, product, fetchUserAddToCart);
//   };

//   const renderStars = (rating) => {
//     return [...Array(5)].map((_, i) => (
//       <Star
//         key={i}
//         size={14}
//         fill={i < Math.floor(rating) ? '#000' : 'none'}
//         className={i < Math.floor(rating) ? 'text-black' : 'text-gray-300'}
//       />
//     ));
//   };

//   const handleBannerClick = (banner) => {
//     if (banner?.ctaLink) {
//       navigate(banner.ctaLink);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-white overflow-hidden">
//       {/* Hero Section - Hero Banner */}
//       <section ref={heroRef} className="relative pt-12 bg-black text-white overflow-hidden">
//         {loadingBanners ? (
//           <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//             <div className="animate-pulse">
//               <div className="h-12 bg-gray-700 rounded w-3/4 mx-auto mb-4"></div>
//               <div className="h-8 bg-gray-700 rounded w-1/2 mx-auto mb-6"></div>
//             </div>
//           </div>
//         ) : banners.hero ? (
//           <>
//             <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//               <motion.div
//                 initial={{ opacity: 0, y: 30 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//               >
//                 {banners.hero.title && (
//                   <h1 className="text-5xl md:text-7xl font-semibold mb-4 tracking-tight">
//                     {banners.hero.title}
//                   </h1>
//                 )}
//                 {banners.hero.subtitle && (
//                   <p className="text-2xl md:text-3xl text-gray-400 mb-6">
//                     {banners.hero.subtitle}
//                   </p>
//                 )}
//                 {banners.hero.ctaText && (
//                   <div className="flex gap-6 justify-center text-lg mb-8">
//                     <button 
//                       onClick={() => handleBannerClick(banners.hero)}
//                       className="text-blue-500 hover:underline"
//                     >
//                       {banners.hero.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </motion.div>
//             </div>
            
//             <div className="w-full h-[600px] relative cursor-pointer" onClick={() => handleBannerClick(banners.hero)}>
//               <img 
//                 src={banners.hero.desktopImage.url}
//                 alt={banners.hero.title || 'Hero Banner'}
//                 className="hidden md:block w-full h-full object-cover"
//               />
//               <img 
//                 src={banners.hero.mobileImage.url}
//                 alt={banners.hero.title || 'Hero Banner'}
//                 className="md:hidden w-full h-full object-cover"
//               />
//             </div>

//             <motion.div
//               animate={{ y: [0, 12, 0] }}
//               transition={{ duration: 1.5, repeat: Infinity }}
//               className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white"
//             >
//               <ChevronDown size={24} />
//             </motion.div>
//           </>
//         ) : (
//           <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//             <p className="text-gray-400">No hero banner available</p>
//           </div>
//         )}
//       </section>

//       {/* Secondary Hero - Basic Banner */}
//       <section className="relative bg-gray-50 overflow-hidden">
//         {loadingBanners ? (
//           <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//             <div className="animate-pulse">
//               <div className="h-10 bg-gray-300 rounded w-2/3 mx-auto mb-4"></div>
//               <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto mb-6"></div>
//             </div>
//           </div>
//         ) : banners.basic ? (
//           <>
//             <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//               <motion.div
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.8 }}
//               >
//                 {banners.basic.title && (
//                   <h2 className="text-4xl md:text-6xl font-semibold mb-3 text-gray-900">
//                     {banners.basic.title}
//                   </h2>
//                 )}
//                 {banners.basic.subtitle && (
//                   <p className="text-xl md:text-2xl text-gray-600 mb-6">
//                     {banners.basic.subtitle}
//                   </p>
//                 )}
//                 {banners.basic.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.basic)}
//                       className="text-blue-600 hover:underline"
//                     >
//                       {banners.basic.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </motion.div>
//             </div>
            
//             <div className="w-full h-[500px] relative cursor-pointer" onClick={() => handleBannerClick(banners.basic)}>
//               <img 
//                 src={banners.basic.desktopImage.url}
//                 alt={banners.basic.title || 'Basic Banner'}
//                 className="hidden md:block w-full h-full object-contain"
//               />
//               <img 
//                 src={banners.basic.mobileImage.url}
//                 alt={banners.basic.title || 'Basic Banner'}
//                 className="md:hidden w-full h-full object-contain"
//               />
//             </div>
//           </>
//         ) : null}
//       </section>

//       {/* Secondary Hero - footer Banner */}
//       <section className="relative bg-gray-50 overflow-hidden">
//         {loadingBanners ? (
//           <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//             <div className="animate-pulse">
//               <div className="h-10 bg-gray-300 rounded w-2/3 mx-auto mb-4"></div>
//               <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto mb-6"></div>
//             </div>
//           </div>
//         ) : banners.footer ? (
//           <>
//             <div className="max-w-[980px] mx-auto px-6 text-center py-16">
//               <motion.div
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.8 }}
//               >
//                 {banners.footer.title && (
//                   <h2 className="text-4xl md:text-6xl font-semibold mb-3 text-gray-900">
//                     {banners.footer.title}
//                   </h2>
//                 )}
//                 {banners.footer.subtitle && (
//                   <p className="text-xl md:text-2xl text-gray-600 mb-6">
//                     {banners.footer.subtitle}
//                   </p>
//                 )}
//                 {banners.footer.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.footer)}
//                       className="text-blue-600 hover:underline"
//                     >
//                       {banners.footer.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </motion.div>
//             </div>
            
//             <div className="w-full h-[500px] relative cursor-pointer" onClick={() => handleBannerClick(banners.footer)}>
//               <img 
//                 src={banners.footer.desktopImage.url}
//                 alt={banners.footer.title || 'Footer Banner'}
//                 className="hidden md:block w-full h-full object-contain"
//               />
//               <img 
//                 src={banners.footer.mobileImage.url}
//                 alt={banners.footer.title || 'Footer Banner'}
//                 className="md:hidden w-full h-full object-contain"
//               />
//             </div>
//           </>
//         ) : null}
//       </section>

//       {/* Two-Column Promos */}
//       <div className="max-w-[1400px] mx-auto px-4 py-4 grid md:grid-cols-2 gap-4">
//         {/* Promotional Banner */}
//         <section className="relative bg-black text-white rounded-3xl overflow-hidden">
//           {loadingBanners ? (
//             <div className="text-center py-12 px-6">
//               <div className="animate-pulse">
//                 <div className="h-8 bg-gray-700 rounded w-1/2 mx-auto mb-4"></div>
//                 <div className="h-6 bg-gray-700 rounded w-1/3 mx-auto"></div>
//               </div>
//             </div>
//           ) : banners.promotional ? (
//             <>
//               <div className="text-center py-12 px-6">
//                 {banners.promotional.title && (
//                   <h3 className="text-3xl md:text-5xl font-semibold mb-2">
//                     {banners.promotional.title}
//                   </h3>
//                 )}
//                 {banners.promotional.subtitle && (
//                   <p className="text-lg text-gray-400 mb-6">
//                     {banners.promotional.subtitle}
//                   </p>
//                 )}
//                 {banners.promotional.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.promotional)}
//                       className="text-blue-500 hover:underline"
//                     >
//                       {banners.promotional.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="h-[300px] relative cursor-pointer" onClick={() => handleBannerClick(banners.promotional)}>
//                 <img 
//                   src={banners.promotional.desktopImage.url}
//                   alt={banners.promotional.title || 'Promotional Banner'}
//                   className="hidden md:block w-full h-full object-cover"
//                 />
//                 <img 
//                   src={banners.promotional.mobileImage.url}
//                   alt={banners.promotional.title || 'Promotional Banner'}
//                   className="md:hidden w-full h-full object-cover"
//                 />
//               </div>
//             </>
//           ) : null}
//         </section>

//         {/* Featured Banner */}
//         <section className="relative bg-gray-100 rounded-3xl overflow-hidden">
//           {loadingBanners ? (
//             <div className="text-center py-12 px-6">
//               <div className="animate-pulse">
//                 <div className="h-8 bg-gray-300 rounded w-1/2 mx-auto mb-4"></div>
//                 <div className="h-6 bg-gray-300 rounded w-1/3 mx-auto"></div>
//               </div>
//             </div>
//           ) : banners.featured ? (
//             <>
//               <div className="text-center py-12 px-6">
//                 {banners.featured.title && (
//                   <h3 className="text-3xl md:text-5xl font-semibold mb-2 text-gray-900">
//                     {banners.featured.title}
//                   </h3>
//                 )}
//                 {banners.featured.subtitle && (
//                   <p className="text-lg text-gray-600 mb-6">
//                     {banners.featured.subtitle}
//                   </p>
//                 )}
//                 {banners.featured.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.featured)}
//                       className="text-blue-600 hover:underline"
//                     >
//                       {banners.featured.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="h-[300px] relative cursor-pointer" onClick={() => handleBannerClick(banners.featured)}>
//                 <img 
//                   src={banners.featured.desktopImage.url}
//                   alt={banners.featured.title || 'Featured Banner'}
//                   className="hidden md:block w-full h-full object-contain"
//                 />
//                 <img 
//                   src={banners.featured.mobileImage.url}
//                   alt={banners.featured.title || 'Featured Banner'}
//                   className="md:hidden w-full h-full object-contain"
//                 />
//               </div>
//             </>
//           ) : null}
//         </section>
//       </div>

//       {/* Two-Column Promos */}
//       <div className="max-w-[1400px] mx-auto px-4 py-4 grid md:grid-cols-2 gap-4">
//         {/* header Banner */}
//         <section className="relative bg-black text-white rounded-3xl overflow-hidden">
//           {loadingBanners ? (
//             <div className="text-center py-12 px-6">
//               <div className="animate-pulse">
//                 <div className="h-8 bg-gray-700 rounded w-1/2 mx-auto mb-4"></div>
//                 <div className="h-6 bg-gray-700 rounded w-1/3 mx-auto"></div>
//               </div>
//             </div>
//           ) : banners.header ? (
//             <>
//               <div className="text-center py-12 px-6">
//                 {banners.header.title && (
//                   <h3 className="text-3xl md:text-5xl font-semibold mb-2">
//                     {banners.header.title}
//                   </h3>
//                 )}
//                 {banners.header.subtitle && (
//                   <p className="text-lg text-gray-400 mb-6">
//                     {banners.header.subtitle}
//                   </p>
//                 )}
//                 {banners.header.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.header)}
//                       className="text-blue-500 hover:underline"
//                     >
//                       {banners.header.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="h-[300px] relative cursor-pointer" onClick={() => handleBannerClick(banners.header)}>
//                 <img 
//                   src={banners.header.desktopImage.url}
//                   alt={banners.header.title || 'Header Banner'}
//                   className="hidden md:block w-full h-full object-cover"
//                 />
//                 <img 
//                   src={banners.header.mobileImage.url}
//                   alt={banners.header.title || 'Header Banner'}
//                   className="md:hidden w-full h-full object-cover"
//                 />
//               </div>
//             </>
//           ) : null}
//         </section>

//         {/* sidebar Banner */}
//         <section className="relative bg-gray-100 rounded-3xl overflow-hidden">
//           {loadingBanners ? (
//             <div className="text-center py-12 px-6">
//               <div className="animate-pulse">
//                 <div className="h-8 bg-gray-300 rounded w-1/2 mx-auto mb-4"></div>
//                 <div className="h-6 bg-gray-300 rounded w-1/3 mx-auto"></div>
//               </div>
//             </div>
//           ) : banners.sidebar ? (
//             <>
//               <div className="text-center py-12 px-6">
//                 {banners.sidebar.title && (
//                   <h3 className="text-3xl md:text-5xl font-semibold mb-2 text-gray-900">
//                     {banners.sidebar.title}
//                   </h3>
//                 )}
//                 {banners.sidebar.subtitle && (
//                   <p className="text-lg text-gray-600 mb-6">
//                     {banners.sidebar.subtitle}
//                   </p>
//                 )}
//                 {banners.sidebar.ctaText && (
//                   <div className="flex gap-6 justify-center text-base">
//                     <button 
//                       onClick={() => handleBannerClick(banners.sidebar)}
//                       className="text-blue-600 hover:underline"
//                     >
//                       {banners.sidebar.ctaText}
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="h-[300px] relative cursor-pointer" onClick={() => handleBannerClick(banners.sidebar)}>
//                 <img 
//                   src={banners.sidebar.desktopImage.url}
//                   alt={banners.sidebar.title || 'Sidebar Banner'}
//                   className="hidden md:block w-full h-full object-contain"
//                 />
//                 <img 
//                   src={banners.sidebar.mobileImage.url}
//                   alt={banners.sidebar.title || 'Sidebar Banner'}
//                   className="md:hidden w-full h-full object-contain"
//                 />
//               </div>
//             </>
//           ) : null}
//         </section>
//       </div>

//       {/* Featured Products Section */}
//       <section ref={productsRef} className="py-20 bg-white fade-in-section">
//         <div className="max-w-[1200px] mx-auto px-6">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-gray-900">
//               Featured Products
//             </h2>
//             <p className="text-xl text-gray-600">
//               Discover our handpicked collection
//             </p>
//           </div>

//           {loadingProducts && (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {Array.from({ length: 6 }).map((_, i) => (
//                 <div key={i} className="animate-pulse">
//                   <div className="bg-gray-200 h-80 rounded-2xl mb-4" />
//                   <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
//                   <div className="h-6 bg-gray-200 rounded w-1/2" />
//                 </div>
//               ))}
//             </div>
//           )}

//           {!loadingProducts && (
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
//               {featuredProducts.slice(0, 6).map((product, i) => (
//                 <motion.div
//                   key={product._id}
//                   initial={{ opacity: 0, y: 40 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.1, duration: 0.6 }}
//                   className="group cursor-pointer"
//                 >
//                   <div className="relative rounded-2xl overflow-hidden bg-gray-50 mb-4">
//                     <div className="relative h-80 overflow-hidden">
//                       <img
//                         src={product.productImage?.[0]}
//                         alt={product.productName}
//                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                       />
                      
//                       {product.featured && (
//                         <div className="absolute top-4 right-4 px-3 py-1 bg-black text-white text-xs font-semibold rounded-full">
//                           FEATURED
//                         </div>
//                       )}

//                       {product.productDiscount && product.productPrice && (
//                         <div className="absolute top-4 left-4 px-3 py-1 bg-red-500 text-white text-xs font-semibold rounded-full">
//                           -{Math.round((product.productDiscount / product.productPrice) * 100)}% OFF
//                         </div>
//                       )}

//                       <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                         <LikeButton productId={product._id} size={20} />
//                       </div>

//                       <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
//                         <button
//                           onClick={() => navigate(`/product/${product._id}`)}
//                           className="px-6 py-3 bg-white text-black rounded-full font-semibold flex items-center gap-2 hover:bg-gray-100 transition"
//                         >
//                           <Eye size={16} />
//                           Quick View
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="px-2">
//                     <div className="flex items-center justify-between mb-2">
//                       <span className="text-xs font-semibold text-orange-600 uppercase">
//                         {product.productsCategory}
//                       </span>
                      
//                       <div className="flex items-center gap-1">
//                         {productRatings[product._id] ? (
//                           <>
//                             {renderStars(productRatings[product._id].average)}
//                             <span className="text-xs text-gray-600 ml-1">
//                               ({productRatings[product._id].average.toFixed(1)})
//                             </span>
//                           </>
//                         ) : (
//                           <span className="text-xs text-gray-400">No reviews</span>
//                         )}
//                       </div>
//                     </div>
                    
//                     <h3 className="text-lg font-semibold mb-2 text-gray-900 line-clamp-2">
//                       {product.productName}
//                     </h3>

//                     <div className="flex items-center justify-between">
//                       <div>
//                         <div className="text-2xl font-semibold text-gray-900">
//                           ₦{product.productPrice?.toLocaleString()}
//                         </div>
//                       </div>
                      
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleAddToCart(e, product);
//                         }}
//                         className="w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center hover:bg-blue-700 transition"
//                       >
//                         <ShoppingCart size={18} />
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}

//           <div className="text-center mt-12">
//             <button
//               onClick={() => navigate('/landing')}
//               className="px-8 py-4 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition inline-flex items-center gap-2"
//             >
//               View All Products
//               <ArrowRight size={18} />
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="py-20 bg-gray-50 fade-in-section">
//         <div className="max-w-[1200px] mx-auto px-6">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl md:text-5xl font-semibold mb-3 text-gray-900">
//               Why Shop With Us
//             </h2>
//             <p className="text-xl text-gray-600">
//               Premium service at every step
//             </p>
//           </div>

//           <div className="grid md:grid-cols-3 gap-8">
//             {[
//               {
//                 icon: <Truck size={40} />,
//                 title: 'Fast, free delivery',
//                 desc: 'Free delivery on all orders over ₦5,000'
//               },
//               {
//                 icon: <Shield size={40} />,
//                 title: 'Extended warranty',
//                 desc: 'Get AppleCare+ for complete peace of mind'
//               },
//               {
//                 icon: <Award size={40} />,
//                 title: 'Expert support',
//                 desc: 'Get help from our Specialists anytime'
//               }
//             ].map((service, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 30 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.15, duration: 0.6 }}
//                 className="text-center p-8"
//               >
//                 <div className="text-gray-900 mb-4 flex justify-center">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-semibold mb-2 text-gray-900">
//                   {service.title}
//                 </h3>
//                 <p className="text-gray-600">
//                   {service.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-50 py-12 border-t border-gray-200">
//         <div className="max-w-[980px] mx-auto px-6">
//           <div className="text-center mb-8">
//             <p className="text-sm text-gray-600 mb-4">
//               More ways to shop: Find a store or other retailer near you. Or call 1-800-MY-PHONE.
//             </p>
//             <div className="flex justify-center gap-4 text-xs text-gray-600">
//               <a href="#" className="hover:underline">Privacy Policy</a>
//               <span>|</span>
//               <a href="#" className="hover:underline">Terms of Use</a>
//               <span>|</span>
//               <a href="#" className="hover:underline">Sales and Refunds</a>
//             </div>
//           </div>
//           <p className="text-center text-xs text-gray-500">
//             Copyright © 2024 JosiePhones Inc. All rights reserved.
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Home;


import React, { useContext, useEffect, useRef, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { 
  ShoppingCart, 
  ChevronDown,
  Award,
  Eye,
  Star,
  Truck,
  Shield,
  ArrowRight
} from 'lucide-react';
import { useTheme } from 'components/Theme/ThemeProvider';
import { useNavigate } from 'react-router-dom';
import addToCart from 'helpers/addToCart';
import Context from "../../context";
import LikeButton from '../../components/ProductLike/LikeButton'; 
import { summaryApi } from "../../common"; 

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  const { colors } = useTheme();
  const { fetchUserAddToCart } = useContext(Context);
  const [scrolled, setScrolled] = useState(false);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [productRatings, setProductRatings] = useState({});
  const [banners, setBanners] = useState({
    hero: null,
    basic: null,
    promotional: null,
    featured: null
  });
  const [loadingBanners, setLoadingBanners] = useState(true);
  const heroRef = useRef(null);
  const productsRef = useRef(null);
  const navigate = useNavigate();

  const { scrollYProgress } = useScroll();

  // Handle scroll
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fetch banners
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setLoadingBanners(true);
        const response = await fetch(summaryApi.getBanners.url, {
          method: summaryApi.getBanners.method
        });
        const data = await response.json();
        
        if (data.success && data.banners) {
          const organizedBanners = {
            hero: data.banners.find(b => b.section === 'hero' && b.isActive),
            basic: data.banners.find(b => b.section === 'basic' && b.isActive),
            promotional: data.banners.find(b => b.section === 'promotional' && b.isActive),
            featured: data.banners.find(b => b.section === 'featured' && b.isActive),
            footer: data.banners.find(b => b.section === 'footer' && b.isActive),
            header: data.banners.find(b => b.section === 'header' && b.isActive),
            sidebar: data.banners.find(b => b.section === 'sidebar' && b.isActive),
            mid_page: data.banners.find(b => b.section === 'mid_page' && b.isActive)
          };
          setBanners(organizedBanners);
        }
      } catch (error) {
        console.error('Error fetching banners:', error);
      } finally {
        setLoadingBanners(false);
      }
    };

    fetchBanners();
  }, []);

  // GSAP animations
  useEffect(() => {
    gsap.fromTo('.fade-in-section',
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: '.fade-in-section',
          start: 'top 85%'
        }
      }
    );
  }, []);

  // Fetch product ratings
  const fetchProductRating = async (productId) => {
    try {
      const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
        method: summaryApi.getReviews.method,
        credentials: 'include'
      });
      const data = await response.json();
      
      if (data.data && data.data.length > 0) {
        const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
        const averageRating = totalRating / data.data.length;
        
        setProductRatings(prev => ({
          ...prev,
          [productId]: {
            average: averageRating,
            count: data.data.length
          }
        }));
      }
    } catch (error) {
      console.error(`Error fetching rating for product ${productId}:`, error);
    }
  };

  // Fetch featured products
  useEffect(() => {
    const fetchFeaturedProducts = async () => {
      try {
        setLoadingProducts(true);
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
        const response = await fetch(`${backendUrl}/api/product/featured-products`);
        const data = await response.json();
        
        if (data.success && data.data) {
          setFeaturedProducts(data.data);
          data.data.forEach(product => {
            fetchProductRating(product._id);
          });
        }
      } catch (error) {
        console.error('Error fetching featured products:', error);
      } finally {
        setLoadingProducts(false);
      }
    };

    fetchFeaturedProducts();
  }, []);

  const handleAddToCart = async (e, product) => {
    await addToCart(e, product, fetchUserAddToCart);
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        size={13}
        fill={i < Math.floor(rating) ? '#1a365d' : 'none'}
        className={i < Math.floor(rating) ? 'text-slate-800' : 'text-gray-400'}
      />
    ));
  };

  const handleBannerClick = (banner) => {
    if (banner?.ctaLink) {
      navigate(banner.ctaLink);
    }
  };

  // Mature formal button component
  const FormalButton = ({ children, onClick, variant = 'primary', className = '' }) => (
    <button
      onClick={onClick}
      className={`
        px-7 py-2.5 font-medium text-xs tracking-wider uppercase transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]
        ${variant === 'primary' 
          ? 'bg-slate-800 text-white hover:bg-slate-900 border border-slate-800' 
          : 'bg-transparent text-slate-800 hover:bg-slate-50 border border-slate-300'
        }
        ${className}
      `}
      style={{ fontFamily: 'Georgia, serif' }}
    >
      {children}
    </button>
  );

  return (
    <div className="min-h-screen bg-neutral-50 mt-[-45px] overflow-hidden" style={{ fontFamily: 'Georgia, serif' }}>
      {/* Navigation Progress Bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-0.5 bg-slate-800 z-50 origin-left"
        style={{ scaleX: scrollYProgress }}
      />

      {/* Hero Section */}
      <section ref={heroRef} className="relative min-h-screen bg-neutral-900 text-white overflow-hidden">
        {loadingBanners ? (
          <div className="relative w-full h-screen flex items-start justify-center pt-32">
            <div className="animate-pulse text-center z-10">
              <div className="h-14 bg-gray-800 w-96 mx-auto mb-6"></div>
              <div className="h-7 bg-gray-800 w-64 mx-auto mb-8"></div>
            </div>
          </div>
        ) : banners.hero ? (
          <div className="relative w-full h-screen cursor-pointer" onClick={() => handleBannerClick(banners.hero)}>
            {/* Background Image */}
            <div className="absolute inset-0">
              <img 
                src={banners.hero.desktopImage.url}
                alt={banners.hero.title || 'Hero Banner'}
                className="hidden md:block w-full h-full object-cover"
              />
              <img 
                src={banners.hero.mobileImage.url}
                alt={banners.hero.title || 'Hero Banner'}
                className="md:hidden w-full h-full object-cover"
              />
            </div>
            
            {/* Text Content Overlay */}
            <div className="relative z-10 h-full flex flex-col items-center text-center px-6 pt-12">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="bg-black/50 backdrop-blur-md p-10 max-w-4xl border border-white/10"
              >
                {banners.hero.title && (
                  <h1 className="text-4xl md:text-6xl lg:text-7xl font-normal mb-5 tracking-tight text-white" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                    {banners.hero.title}
                  </h1>
                )}
                {banners.hero.subtitle && (
                  <p className="text-lg md:text-xl text-black mb-8 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
                    {banners.hero.subtitle}
                  </p>
                )}
                {banners.hero.ctaText && (
                  <div className="flex gap-5 justify-center items-center text-slate-200">
                    <FormalButton onClick={() => handleBannerClick(banners.hero)}>
                      {banners.hero.ctaText}
                    </FormalButton>
                    <button className="text-sm text-slate-800 hover:text-white font-light tracking-wide uppercase" style={{ fontFamily: 'Georgia, serif' }}>
                      Learn more →
                    </button>
                  </div>
                )}
              </motion.div>
            </div>

            {/* Scroll Indicator */}
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
            >
              <ChevronDown size={22} className="text-neutral-300" />
            </motion.div>
          </div>
        ) : (
          <div className="relative w-full h-screen flex items-start justify-center pt-32">
            <p className="text-neutral-400 text-lg z-10 bg-black/50 backdrop-blur-md p-5 border border-white/10" style={{ fontFamily: 'Georgia, serif' }}>No hero banner available</p>
          </div>
        )}
      </section>

      {/* Secondary Banner Sections */}
      {['basic', 'footer', 'mid_page'].map((bannerType) => (
  banners[bannerType] && (
    <section
      key={bannerType}
      className="relative w-full h-auto bg-neutral-100 overflow-hidden mt-2"
    >
      <div
        className="relative w-full cursor-pointer"
        onClick={() => handleBannerClick(banners[bannerType])}
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={banners[bannerType].desktopImage.url}
            alt={banners[bannerType].title || `${bannerType} Banner`}
            className="hidden md:block w-full h-full object-cover"
          />
          <img
            src={banners[bannerType].mobileImage.url}
            alt={banners[bannerType].title || `${bannerType} Banner`}
            className="md:hidden w-full h-full object-cover"
          />
        </div>

        {/* Text Overlay */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-6 py-20 md:py-32 bg-black/50 backdrop-blur-md">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="p-10 max-w-4xl border border-white/10"
          >
            {banners[bannerType].title && (
              <h2 className="text-3xl md:text-5xl font-normal mb-4 text-[#787af3] tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                {banners[bannerType].title}
              </h2>
            )}
            {banners[bannerType].subtitle && (
              <p className="text-lg text-neutral-100 mb-8 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
                {banners[bannerType].subtitle}
              </p>
            )}
            {banners[bannerType].ctaText && (
              <div className="flex gap-5 justify-center text-slate-200">
                <FormalButton onClick={() => handleBannerClick(banners[bannerType])}>
                  {banners[bannerType].ctaText}
                </FormalButton>
                <button className="text-sm text-slate-800 hover:text-white font-light tracking-wide uppercase" style={{ fontFamily: 'Georgia, serif' }}>
                  Learn more →
                </button>
              </div>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  )
))}

      {/* Promotional Grid */}
      <div className="w-full grid md:grid-cols-2 gap-2">
        {['promotional', 'featured', 'header', 'sidebar'].map((bannerType) => (
          banners[bannerType] && (
            <section key={bannerType} className="relative min-h-[80vh] overflow-hidden group cursor-pointer mt-2 gap-2">
              {/* Background Image */}
              <div className="absolute inset-0">
                <img 
                  src={banners[bannerType].desktopImage.url}
                  alt={banners[bannerType].title || `${bannerType} Banner`}
                  className="hidden md:block w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <img 
                  src={banners[bannerType].mobileImage.url}
                  alt={banners[bannerType].title || `${bannerType} Banner`}
                  className="md:hidden w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              
              {/* Text Content Overlay */}
              <div className="relative z-10 h-full flex flex-col items-center text-center px-6 pt-20">
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6 }}
                  className="bg-black/50 backdrop-blur-md p-8 max-w-md border border-white/10"
                >
                  {banners[bannerType].title && (
                    <h3 className="text-2xl md:text-3xl font-normal mb-3 text-[#a5a6f7] tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                      {banners[bannerType].title}
                    </h3>
                  )}
                  {banners[bannerType].subtitle && (
                    <p className="text-base text-neutral-200 mb-6 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
                      {banners[bannerType].subtitle}
                    </p>
                  )}
                  {banners[bannerType].ctaText && (
                    <FormalButton 
                      variant="primary"
                      onClick={() => handleBannerClick(banners[bannerType])}
                      className='text-slate-200'
                    >
                      {banners[bannerType].ctaText}
                    </FormalButton>
                  )}
                </motion.div>
              </div>
            </section>
          )
        ))}
      </div>

      {/* Section Spacing */}
      <div className="mt-2"></div>

      {/* Featured Products Section */}
      <section ref={productsRef} className="py-24 bg-neutral-50 fade-in-section">
        <div className="max-w-6xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-20"
          >
            <h2 className="text-4xl md:text-5xl font-normal mb-4 text-neutral-900 tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
              Featured Products
            </h2>
            <p className="text-lg text-neutral-600 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
              Discover our handpicked collection
            </p>
          </motion.div>

          {loadingProducts && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="animate-pulse">
                  <div className="bg-neutral-200 h-80 mb-6" />
                  <div className="h-4 bg-neutral-200 w-3/4 mb-3" />
                  <div className="h-6 bg-neutral-200 w-1/2" />
                </div>
              ))}
            </div>
          )}

          {!loadingProducts && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {featuredProducts.slice(0, 6).map((product, i) => (
                <motion.div
                  key={product._id}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1, duration: 0.6 }}
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden bg-neutral-100 mb-6">
                    <div className="relative h-80 overflow-hidden">
                      <img
                        src={product.productImage?.[0]}
                        alt={product.productName}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      
                      {/* Product Badges */}
                      <div className="absolute top-4 right-4 flex flex-col gap-2">
                        {product.featured && (
                          <div className="px-3 py-1 bg-neutral-900 text-neutral-200 text-[10px] font-medium tracking-widest uppercase" style={{ fontFamily: 'Georgia, serif' }}>
                            FEATURED
                          </div>
                        )}
                        {product.productDiscount && product.productPrice && (
                          <div className="px-3 py-1 bg-red-700 text-neutral-200 text-[10px] font-medium tracking-widest uppercase" style={{ fontFamily: 'Georgia, serif' }}>
                            -{Math.round((product.productDiscount / product.productPrice) * 100)}% OFF
                          </div>
                        )}
                      </div>

                      {/* Like Button */}
                      <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <LikeButton productId={product._id} size={20} />
                      </div>

                      {/* Quick View Overlay */}
                      <div className="absolute inset-0 bg-neutral-900/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <div className="flex gap-4">
                          <button
                            onClick={() => navigate(`/product/${product._id}`)}
                            className="px-6 py-2.5 bg-white text-neutral-900 font-medium text-xs uppercase tracking-wider flex items-center gap-2 hover:bg-neutral-100 transition transform hover:scale-[1.02]"
                            style={{ fontFamily: 'Georgia, serif' }}
                          >
                            <Eye size={15} />
                            Quick View
                          </button>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddToCart(e, product);
                            }}
                            className="w-11 h-11 bg-slate-800 text-white flex items-center justify-center hover:bg-slate-900 transition transform hover:scale-[1.02]"
                          >
                            <ShoppingCart size={17} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="px-2">
                    {/* Category and Rating */}
                    <div className="flex items-center justify-between mb-3">
                      <span className="text-[10px] font-medium text-neutral-500 uppercase tracking-widest" style={{ fontFamily: 'Georgia, serif' }}>
                        {product.productsCategory}
                      </span>
                      
                      <div className="flex items-center gap-1">
                        {productRatings[product._id] ? (
                          <>
                            {renderStars(productRatings[product._id].average)}
                            <span className="text-xs text-neutral-500 ml-1" style={{ fontFamily: 'Georgia, serif' }}>
                              ({productRatings[product._id].count})
                            </span>
                          </>
                        ) : (
                          <span className="text-xs text-neutral-400" style={{ fontFamily: 'Georgia, serif' }}>No reviews</span>
                        )}
                      </div>
                    </div>
                    
                    {/* Product Name */}
                    <h3 className="text-lg font-normal mb-3 text-neutral-900 line-clamp-2 leading-snug tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                      {product.productName}
                    </h3>

                    {/* Price and Add to Cart */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-baseline gap-2">
                        <div className="text-xl font-normal text-neutral-900" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                          ₦{product.productPrice?.toLocaleString()}
                        </div>
                        {product.productDiscount && (
                          <div className="text-base text-neutral-500 line-through" style={{ fontFamily: 'Georgia, serif' }}>
                            ₦{(product.productPrice + product.productDiscount)?.toLocaleString()}
                          </div>
                        )}
                      </div>
                      
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddToCart(e, product);
                        }}
                        className="w-10 h-10 bg-slate-800 text-neutral-200 flex items-center justify-center hover:bg-slate-900 transition transform hover:scale-[1.02] active:scale-[0.98]"
                      >
                        <ShoppingCart size={17} />
                      </button>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}

          {/* View All Button */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="text-center mt-16"
          >
            <FormalButton 
              onClick={() => navigate('/landing')}
              className="px-9 py-3.5 text-xs inline-flex text-neutral-200 items-center gap-2"
            >
              View All Products
              <ArrowRight size={16} />
            </FormalButton>
          </motion.div>
        </div>
      </section>

      {/* Section Spacing */}
      <div className="mt-2"></div>

      {/* Services Section */}
      <section className="py-24 bg-neutral-100 fade-in-section">
        <div className="max-w-6xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-20"
          >
            <h2 className="text-4xl md:text-5xl font-normal mb-4 text-neutral-900 tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
              Why Shop With Us
            </h2>
            <p className="text-lg text-neutral-600 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
              Premium service at every step
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-12">
            {[
              {
                icon: <Truck size={44} />,
                title: 'Fast, Free Delivery',
                desc: 'Free delivery on all orders over ₦500,000'
              },
              {
                icon: <Shield size={44} />,
                title: 'Extended Warranty',
                desc: 'Get complete peace of mind with our protection plans'
              },
              {
                icon: <Award size={44} />,
                title: 'Expert Support',
                desc: 'Get help from our Specialists anytime'
              }
            ].map((service, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15, duration: 0.6 }}
                className="text-center p-8"
              >
                <div className="text-slate-800 mb-6 flex justify-center">
                  {service.icon}
                </div>
                <h3 className="text-xl font-normal mb-4 text-neutral-900 tracking-tight" style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                  {service.title}
                </h3>
                <p className="text-base text-neutral-600 font-light leading-relaxed tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
                  {service.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-neutral-50 py-16 border-t border-neutral-300 mt-2">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-8">
            <p className="text-xs text-neutral-600 mb-6 font-light tracking-wide" style={{ fontFamily: 'Georgia, serif' }}>
              More ways to shop: Visit our store or browse our website. Or call 080-365-MY-PHONE.
            </p>
            <div className="flex justify-center gap-6 text-[11px] text-neutral-600 uppercase tracking-widest">
              <a href="#" className="hover:text-neutral-900 font-light" style={{ fontFamily: 'Georgia, serif' }}>Facebook</a>
              <a href="#" className="hover:text-neutral-900 font-light" style={{ fontFamily: 'Georgia, serif' }}>Instagram</a>
              <a href="#" className="hover:text-neutral-900 font-light" style={{ fontFamily: 'Georgia, serif' }}>Tik Tok</a>
            </div>
          </div>
          
        </div>
      </footer>
    </div>
  );
};

export default Home;

// import React, { useContext, useEffect, useRef, useState } from 'react';
// import { motion, useScroll } from 'framer-motion';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { 
//   ShoppingCart, 
//   Search,
//   Star,
//   Eye,
//   ArrowRight,
//   Shield,
//   Smartphone,
//   Headphones,
//   Award,
//   ChevronRight,
//   MapPin,
//   Phone,
//   Twitter,
//   MessageCircle,
//   Facebook,
//   Instagram,
//   Linkedin
// } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { useTheme } from 'components/Theme/ThemeProvider';
// import Context from "../../context";
// import addToCart from 'helpers/addToCart';
// import LikeButton from '../../components/ProductLike/LikeButton'; 
// import { summaryApi } from "../../common";

// gsap.registerPlugin(ScrollTrigger);

// const Home = () => {
//   const { colors } = useTheme();
//   const { fetchUserAddToCart } = useContext(Context);
//   const navigate = useNavigate();
//   const { scrollYProgress } = useScroll();
  
//   // State Management
//   const [scrolled, setScrolled] = useState(false);
//   const [featuredProducts, setFeaturedProducts] = useState([]);
//   const [accessories, setAccessories] = useState([]);
//   const [loadingProducts, setLoadingProducts] = useState(true);
//   const [loadingAccessories, setLoadingAccessories] = useState(true);
//   const [productRatings, setProductRatings] = useState({});
//   const [activeCategory, setActiveCategory] = useState('All');
//   const [banners, setBanners] = useState({
//     hero: null,
//     basic: null,
//     promotional: null,
//     featured: null
//   });
//   const [loadingBanners, setLoadingBanners] = useState(true);
//   const [email, setEmail] = useState('');

//   // Refs
//   const heroRef = useRef(null);
//   const productsRef = useRef(null);

//   // Handle scroll
//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Fetch banners
//   useEffect(() => {
//     const fetchBanners = async () => {
//       try {
//         setLoadingBanners(true);
//         const response = await fetch(summaryApi.getBanners.url, {
//           method: summaryApi.getBanners.method
//         });
//         const data = await response.json();
        
//         if (data.success && data.banners) {
//           const organizedBanners = {
//             hero: data.banners.find(b => b.section === 'hero' && b.isActive),
//             basic: data.banners.find(b => b.section === 'basic' && b.isActive),
//             promotional: data.banners.find(b => b.section === 'promotional' && b.isActive),
//             featured: data.banners.find(b => b.section === 'featured' && b.isActive),
//           };
//           setBanners(organizedBanners);
//         }
//       } catch (error) {
//         console.error('Error fetching banners:', error);
//       } finally {
//         setLoadingBanners(false);
//       }
//     };

//     fetchBanners();
//   }, []);

//   // GSAP animations
//   useEffect(() => {
//     gsap.fromTo('.fade-in-section',
//       { opacity: 0, y: 40 },
//       {
//         opacity: 1,
//         y: 0,
//         duration: 0.8,
//         stagger: 0.15,
//         ease: 'power2.out',
//         scrollTrigger: {
//           trigger: '.fade-in-section',
//           start: 'top 85%'
//         }
//       }
//     );
//   }, []);

//   // Fetch product ratings
//   const fetchProductRating = async (productId) => {
//     try {
//       const response = await fetch(`${summaryApi.getReviews.url}/${productId}`, {
//         method: summaryApi.getReviews.method,
//         credentials: 'include'
//       });
//       const data = await response.json();
      
//       if (data.data && data.data.length > 0) {
//         const totalRating = data.data.reduce((sum, review) => sum + review.rating, 0);
//         const averageRating = totalRating / data.data.length;
        
//         setProductRatings(prev => ({
//           ...prev,
//           [productId]: {
//             average: averageRating,
//             count: data.data.length
//           }
//         }));
//       }
//     } catch (error) {
//       console.error(`Error fetching rating for product ${productId}:`, error);
//     }
//   };

//   // Fetch featured products
//   useEffect(() => {
//     const fetchFeaturedProducts = async () => {
//       try {
//         setLoadingProducts(true);
//         const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//         const response = await fetch(`${backendUrl}/api/product/featured-products`);
//         const data = await response.json();
        
//         if (data.success && data.data) {
//           setFeaturedProducts(data.data);
//           data.data.forEach(product => {
//             fetchProductRating(product._id);
//           });
//         }
//       } catch (error) {
//         console.error('Error fetching featured products:', error);
//       } finally {
//         setLoadingProducts(false);
//       }
//     };

//     fetchFeaturedProducts();
//   }, []);

//   // Fetch accessories
//   useEffect(() => {
//     const fetchAccessories = async () => {
//       try {
//         setLoadingAccessories(true);
//         const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
//         const response = await fetch(`${backendUrl}/api/product/all-products`);
//         const data = await response.json();
        
//         if (data.success && data.data) {
//           // Filter for accessories categories
//           const accessoryCategories = ['Cases', 'Cables', 'Chargers', 'Speakers', 'Headsets', 'Earphones', 'Airtags'];
//           const filteredAccessories = data.data.filter(product => 
//             accessoryCategories.some(cat => 
//               product.productsCategory?.toLowerCase().includes(cat.toLowerCase())
//             )
//           );
//           setAccessories(filteredAccessories);
//         }
//       } catch (error) {
//         console.error('Error fetching accessories:', error);
//       } finally {
//         setLoadingAccessories(false);
//       }
//     };

//     fetchAccessories();
//   }, []);

//   const handleAddToCart = async (e, product) => {
//     e.stopPropagation();
//     await addToCart(e, product, fetchUserAddToCart);
//   };

//   const handleBannerClick = (banner) => {
//     if (banner?.ctaLink) {
//       navigate(banner.ctaLink);
//     }
//   };

//   const renderStars = (rating) => {
//     return [...Array(5)].map((_, i) => (
//       <Star
//         key={i}
//         size={14}
//         fill={i < Math.floor(rating) ? '#1e3a8a' : 'none'}
//         className={i < Math.floor(rating) ? 'text-blue-900' : 'text-gray-300'}
//       />
//     ));
//   };

//   const handleEmailSubmit = (e) => {
//     e.preventDefault();
//     console.log('Newsletter signup:', email);
//     setEmail('');
//   };

//   const categoryFilters = ['All', 'Cases', 'Cables', 'Chargers', 'Speakers', 'Tripod', 'Headsets', 'Earphones', 'Airtags'];

//   const filteredAccessories = activeCategory === 'All' 
//     ? accessories 
//     : accessories.filter(product => 
//         product.productsCategory?.toLowerCase().includes(activeCategory.toLowerCase())
//       );

//   return (
//     <div className="min-h-screen bg-white overflow-hidden">
//       {/* Progress Bar */}
//       <motion.div
//         className="fixed top-0 left-0 right-0 h-1 bg-blue-900 z-50 origin-left"
//         style={{ scaleX: scrollYProgress }}
//       />

//       {/* Top Banner */}
//       <div className="w-full bg-blue-900 py-3 px-6">
//         <div className="max-w-[90rem] mx-auto flex justify-between items-center">
//           <p className="text-white text-lg md:text-xl font-medium text-center flex-1">
//             Detty December Deals Coming Soon!
//           </p>
//           <div className="hidden md:block">
//             <Award className="text-orange-500" size={24} />
//           </div>
//         </div>
//       </div>

//       {/* Hero Section with Navigation */}
//       <section className="relative bg-gradient-to-b from-gray-50 to-white">
//         {/* Navigation */}
//         <nav className="sticky top-0 z-40 bg-white/95 backdrop-blur-md shadow-sm">
//           <div className="max-w-[90rem] mx-auto px-6 py-4">
//             <div className="flex items-center justify-between">
//               {/* Logo */}
//               <div className="flex items-center gap-2">
//                 <Smartphone className="text-blue-900" size={32} />
//                 <span className="text-2xl font-bold text-blue-900">JosiePhones</span>
//               </div>

//               {/* Nav Links */}
//               <div className="hidden md:flex items-center gap-8">
//                 <button className="flex items-center gap-2 text-gray-900 font-semibold hover:text-blue-900 transition">
//                   <Star className="text-orange-500" size={20} />
//                   FLASH DEALS
//                 </button>
//                 <button className="flex items-center gap-1 text-gray-900 font-semibold hover:text-blue-900 transition">
//                   TRADE-IN
//                   <ChevronRight size={18} />
//                 </button>
//                 <button className="text-gray-900 font-semibold hover:text-blue-900 transition">
//                   GIFT CARDS
//                 </button>
//               </div>

//               {/* Search & CTA */}
//               <div className="flex items-center gap-4">
//                 <div className="hidden lg:flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-full">
//                   <Search className="text-gray-500" size={18} />
//                   <input 
//                     type="text" 
//                     placeholder="Search..." 
//                     className="bg-transparent text-sm text-gray-700 outline-none w-40"
//                   />
//                 </div>
//                 <button 
//                   onClick={() => navigate('/login')}
//                   className="flex items-center gap-2 px-6 py-2 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition"
//                 >
//                   GET STARTED
//                   <ArrowRight size={16} />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </nav>

//         {/* Hero Content */}
//         <div className="max-w-[90rem] mx-auto px-6 py-16 md:py-24">
//           <div className="grid md:grid-cols-2 gap-12 items-center">
//             {/* Left: Text Content */}
//             <motion.div
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8 }}
//               className="space-y-6"
//             >
//               <h1 className="text-6xl md:text-8xl font-bold text-gray-900 leading-tight">
//                 Upgrade the way you Connect.
//               </h1>
//               <p className="text-xl text-gray-700 max-w-md leading-relaxed">
//                 Shop the latest Apple devices and top gadget brands — iPhone, MacBook, AirPods, Smartwatches, and more. All in one trusted store.
//               </p>
//               <div className="flex gap-4">
//                 <button 
//                   onClick={() => navigate('/landing')}
//                   className="px-8 py-4 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition transform hover:scale-105"
//                 >
//                   Shop Now
//                 </button>
//                 <button 
//                   onClick={() => navigate('/trade-in')}
//                   className="px-8 py-4 border-2 border-orange-500 text-gray-900 rounded-full font-semibold hover:bg-orange-50 transition"
//                 >
//                   Trade in Your Device
//                 </button>
//               </div>
//             </motion.div>

//             {/* Right: Hero Image */}
//             <motion.div
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.8, delay: 0.2 }}
//               className="relative"
//             >
//               {banners.hero ? (
//                 <img 
//                   src={banners.hero.desktopImage.url}
//                   alt="Hero"
//                   className="w-full h-auto rounded-3xl shadow-2xl"
//                 />
//               ) : (
//                 <div className="w-full h-[500px] bg-gradient-to-br from-blue-900 to-blue-600 rounded-3xl shadow-2xl flex items-center justify-center">
//                   <Smartphone className="text-white" size={120} />
//                 </div>
//               )}
//             </motion.div>
//           </div>
//         </div>

//         {/* Brand Logos */}
//         <div className="max-w-[90rem] mx-auto px-6 pb-16">
//           <div className="bg-white/60 backdrop-blur-md rounded-[31.22rem] p-6 shadow-lg">
//             <div className="flex justify-around items-center flex-wrap gap-8">
//               {[Shield, Award, Smartphone, Headphones, Star].map((Icon, i) => (
//                 <Icon key={i} className="text-gray-400 hover:text-blue-900 transition" size={40} />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Top Picks Section */}
//       <section className="py-20 bg-white fade-in-section" ref={productsRef}>
//         <div className="max-w-[90rem] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
//               Top Picks this Season
//             </h2>
//             <p className="text-xl text-gray-600 mb-8">
//               Explore the most loved tech — from the newest iPhones to high-performance accessories.
//             </p>
//             <button 
//               onClick={() => navigate('/landing')}
//               className="px-8 py-3 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition"
//             >
//               View all Products
//             </button>
//           </motion.div>

//           {/* Featured Products Grid */}
//           {loadingProducts ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//               {Array.from({ length: 4 }).map((_, i) => (
//                 <div key={i} className="animate-pulse">
//                   <div className="bg-gray-200 h-96 rounded-2xl mb-4" />
//                   <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
//                   <div className="h-6 bg-gray-200 rounded w-1/2" />
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//               {featuredProducts.slice(0, 4).map((product, i) => (
//                 <motion.div
//                   key={product._id}
//                   initial={{ opacity: 0, y: 50 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.1 }}
//                   className="group cursor-pointer"
//                   onClick={() => navigate(`/product/${product._id}`)}
//                 >
//                   <div className="relative rounded-2xl overflow-hidden bg-gray-100 mb-4">
//                     <div className="relative h-96 overflow-hidden">
//                       <img
//                         src={product.productImage?.[0]}
//                         alt={product.productName}
//                         className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                       />
                      
//                       {/* Like Button */}
//                       <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
//                         <LikeButton productId={product._id} size={20} />
//                       </div>

//                       {/* Quick Actions */}
//                       <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-3">
//                         <button
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             navigate(`/product/${product._id}`);
//                           }}
//                           className="px-6 py-3 bg-white text-black rounded-full font-semibold flex items-center gap-2 hover:bg-gray-100"
//                         >
//                           <Eye size={16} />
//                           View
//                         </button>
//                         <button
//                           onClick={(e) => handleAddToCart(e, product)}
//                           className="w-12 h-12 rounded-full bg-blue-900 text-white flex items-center justify-center hover:bg-blue-800"
//                         >
//                           <ShoppingCart size={18} />
//                         </button>
//                       </div>
//                     </div>

//                     {/* Product Info Overlay */}
//                     <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
//                       <h3 className="text-2xl font-bold mb-2 line-clamp-2">
//                         {product.productName}
//                       </h3>
//                       <div className="flex items-center justify-between">
//                         <div className="flex items-center gap-1">
//                           {productRatings[product._id] ? (
//                             <>
//                               {renderStars(productRatings[product._id].average)}
//                               <span className="text-sm ml-1">
//                                 ({productRatings[product._id].count})
//                               </span>
//                             </>
//                           ) : (
//                             <span className="text-sm">No reviews</span>
//                           )}
//                         </div>
//                         <div className="text-2xl font-bold">
//                           ₦{product.productPrice?.toLocaleString()}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Trade-In Section */}
//       <section className="py-20 bg-gray-50">
//         <div className="max-w-[90rem] mx-auto px-6">
//           <div className="grid md:grid-cols-2 gap-12 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               className="relative"
//             >
//               {banners.basic ? (
//                 <img 
//                   src={banners.basic.desktopImage.url}
//                   alt="Trade-in"
//                   className="w-full h-auto rounded-3xl shadow-2xl"
//                 />
//               ) : (
//                 <div className="w-full h-[500px] bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl shadow-2xl" />
//               )}
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, x: 50 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               className="space-y-6"
//             >
//               <h2 className="text-6xl font-bold text-gray-900 leading-tight">
//                 Trade Smart. Upgrade Smarter.
//               </h2>
//               <p className="text-xl text-gray-700 leading-relaxed">
//                 Exchange your old device for instant credit toward your next purchase. We'll inspect, value, and apply your trade-in in minutes — online or in-store.
//               </p>
//               <button 
//                 onClick={() => navigate('/trade-in')}
//                 className="px-8 py-4 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition transform hover:scale-105"
//               >
//                 Start trade-in
//               </button>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Why Shop With Us */}
//       <section className="py-20 bg-white fade-in-section">
//         <div className="max-w-[90rem] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="text-center mb-16"
//           >
//             <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
//               Why Tech Lovers love to shop with us
//             </h2>
//             <button className="mt-6 px-8 py-3 border-2 border-orange-500 text-gray-900 rounded-full font-semibold hover:bg-orange-50 transition flex items-center gap-2 mx-auto">
//               Learn More
//               <ArrowRight size={18} />
//             </button>
//           </motion.div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {[
//               {
//                 icon: Shield,
//                 title: 'Extended Warranty and Insurance',
//                 subtitle: '2-years coverage',
//                 desc: 'Comprehensive coverage for your devices with screen repair included*',
//                 bg: 'bg-blue-900',
//                 textColor: 'text-white',
//                 borderColor: 'border-orange-500'
//               },
//               {
//                 icon: Smartphone,
//                 title: 'All Networks available',
//                 subtitle: 'MTN, Airtel, Glo and others...',
//                 desc: 'Choose from all major network carriers. Get the best deal and data plan',
//                 bg: 'bg-blue-900',
//                 textColor: 'text-white',
//                 borderColor: 'border-orange-500'
//               },
//               {
//                 icon: Headphones,
//                 title: '24/7 Support Assistance',
//                 subtitle: 'Always online',
//                 desc: 'From setting up to troubleshooting, we\'re here to help anytime.',
//                 bg: 'bg-blue-900',
//                 textColor: 'text-white',
//                 borderColor: 'border-orange-500'
//               },
//               {
//                 icon: Award,
//                 title: 'Maximum value guaranteed',
//                 subtitle: 'Up to ₦150,000.00',
//                 desc: 'Trade-in your old device and get back instant cash on new purchases.',
//                 bg: 'bg-orange-500',
//                 textColor: 'text-white',
//                 borderColor: 'border-amber-900'
//               }
//             ].map((service, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 className={`${service.bg} rounded-2xl p-6 shadow-xl flex flex-col justify-between h-[400px]`}
//               >
//                 <service.icon className="text-white mb-4" size={48} />
//                 <div className="flex-1">
//                   <h3 className={`text-2xl font-semibold mb-2 ${service.textColor}`}>
//                     {service.title}
//                   </h3>
//                   <p className={`font-medium mb-4 ${service.textColor}`}>
//                     {service.subtitle}
//                   </p>
//                   <p className="text-gray-300 leading-relaxed">
//                     {service.desc}
//                   </p>
//                 </div>
//                 <button className={`mt-4 px-6 py-3 border-2 ${service.borderColor} rounded-full font-semibold hover:bg-white/10 transition flex items-center gap-2 ${service.textColor}`}>
//                   Learn More
//                   <ArrowRight size={16} />
//                 </button>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Accessories Section */}
//       <section className="py-20 bg-gray-50">
//         <div className="max-w-[90rem] mx-auto px-6">
//           <motion.div
//             initial={{ opacity: 0, y: 40 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             className="mb-12"
//           >
//             <h2 className="text-6xl font-bold text-gray-900 mb-2">
//               Add-on & Accessories
//             </h2>
//             <p className="text-xl text-gray-700 mb-8">Complete Your Setup</p>

//             {/* Category Filters */}
//             <div className="flex flex-wrap gap-3 mb-8">
//               {categoryFilters.map((category) => (
//                 <button
//                   key={category}
//                   onClick={() => setActiveCategory(category)}
//                   className={`px-6 py-3 rounded-full font-semibold transition ${
//                     activeCategory === category
//                       ? 'bg-blue-900 text-white'
//                       : 'border-2 border-gray-300 text-gray-700 hover:border-blue-900'
//                   }`}
//                 >
//                   {category}
//                 </button>
//               ))}
//             </div>
//           </motion.div>

//           {/* Accessories Grid */}
//           {loadingAccessories ? (
//             <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
//               {Array.from({ length: 8 }).map((_, i) => (
//                 <div key={i} className="animate-pulse">
//                   <div className="bg-gray-200 h-48 rounded-xl" />
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
//               {filteredAccessories.slice(0, 8).map((product, i) => (
//                 <motion.div
//                   key={product._id}
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   whileInView={{ opacity: 1, scale: 1 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.05 }}
//                   className="group cursor-pointer"
//                   onClick={() => navigate(`/product/${product._id}`)}
//                 >
//                   <div className="bg-gray-200/60 rounded-xl p-4 hover:shadow-lg transition">
//                     <div className="relative h-48 mb-2">
//                       <img
//                         src={product.productImage?.[0]}
//                         alt={product.productName}
//                         className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
//                       />
//                     </div>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Testimonials */}
//       <section className="py-20 bg-gray-900 text-white">
//         <div className="max-w-[90rem] mx-auto px-6">
//           <h2 className="text-5xl font-bold text-center mb-16">
//             What our Customers says about us
//           </h2>

//           <div className="grid md:grid-cols-3 gap-6 mb-12">
//             {[
//               {
//                 name: 'Daniel',
//                 role: 'Online Customer',
//                 review: 'Got my iPhone 15 Pro in 2 hours. Perfect service.',
//                 rating: 5
//               },
//               {
//                 name: 'Tife',
//                 role: 'Walk-in Customer',
//                 review: 'Trusted them with a trade-in. Smooth process and fair value',
//                 rating: 5
//               },
//               {
//                 name: 'Aisha',
//                 role: 'Online Customer',
//                 review: 'Best tech store I\'ve ordered from in Nigeria. Reached out via Instagram',
//                 rating: 5
//               }
//             ].map((testimonial, i) => (
//               <motion.div
//                 key={i}
//                 initial={{ opacity: 0, y: 50 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1 }}
//                 className="bg-white/10 backdrop-blur-md rounded-xl p-6"
//               >
//                 <div className="flex gap-1 mb-4">
//                   {[...Array(testimonial.rating)].map((_, j) => (
//                     <Star key={j} fill="#FFA500" className="text-orange-500" size={20} />
//                   ))}
//                 </div>
//                 <p className="text-xl mb-6">{testimonial.review}</p>
//                 <div className="flex items-center gap-4">
//                   <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center font-bold text-xl">
//                     {testimonial.name[0]}
//                   </div>
//                   <div>
//                     <p className="font-semibold text-lg">{testimonial.name}</p>
//                     <p className="text-gray-300">{testimonial.role}</p>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>

//           <div className="text-center">
//             <button className="px-8 py-4 bg-blue-900 text-white rounded-full font-semibold hover:bg-blue-800 transition">
//               Read More Reviews
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Newsletter & Footer */}
//       <footer className="bg-blue-900 text-white py-16">
//         <div className="max-w-[90rem] mx-auto px-6">
//           {/* Newsletter Section */}
//           <div className="bg-gradient-to-r from-blue-800 to-blue-700 rounded-3xl p-12 mb-12">
//             <div className="grid md:grid-cols-2 gap-8 items-center">
//               <div>
//                 <h3 className="text-5xl font-bold mb-4">Stay Ahead of the Drop.</h3>
//                 <p className="text-xl text-blue-200">
//                   Be the first to know when new devices launch or prices drop.
//                 </p>
//               </div>
//               <form onSubmit={handleEmailSubmit} className="flex gap-2">
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="Email Address"
//                   className="flex-1 px-6 py-4 rounded-full text-gray-900 outline-none"
//                   required
//                 />
//                 <button
//                   type="submit"
//                   className="px-8 py-4 bg-white text-blue-900 rounded-full font-semibold hover:bg-gray-100 transition"
//                 >
//                   Join the List
//                 </button>
//               </form>
//             </div>
//           </div>

//           {/* Footer Content */}
//           <div className="grid md:grid-cols-2 gap-12 mb-12">
//             {/* Company Info */}
//             <div>
//               <div className="flex items-center gap-2 mb-6">
//                 <Smartphone size={40} />
//                 <span className="text-3xl font-bold">JosiePhones</span>
//               </div>
//               <p className="text-xl text-blue-200 mb-6 max-w-md">
//                 Your trusted source for genuine Apple products and premium gadgets. Secure payment. Fast delivery. Real support.
//               </p>
//             </div>

//             {/* Contact Info */}
//             <div className="space-y-6">
//               <div className="flex flex-wrap gap-3">
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <MapPin size={18} />
//                   <span className="text-sm">Suite D6, Diamond Plaza, Beside UBA Bank</span>
//                 </div>
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <span className="text-sm">Computer Village, Ikeja</span>
//                 </div>
//               </div>

//               <div className="flex flex-wrap gap-3">
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <Phone size={18} />
//                 </div>
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <span className="text-sm">+234 805 998 7568</span>
//                 </div>
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <span className="text-sm">+234 902 391 8155</span>
//                 </div>
//                 <div className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full">
//                   <span className="text-sm">+234 911 951 2726</span>
//                 </div>
//               </div>

//               {/* Social Links */}
//               <div className="flex flex-wrap gap-3">
//                 {[
//                   { icon: Twitter, label: 'Twitter' },
//                   { icon: MessageCircle, label: 'WhatsApp' },
//                   { icon: Facebook, label: 'Facebook' },
//                   { icon: Instagram, label: 'Instagram' },
//                   { icon: Linkedin, label: 'LinkedIn' }
//                 ].map((social, i) => (
//                   <button
//                     key={i}
//                     className="flex items-center gap-2 px-4 py-2 border border-white/30 rounded-full hover:bg-white/10 transition"
//                   >
//                     <social.icon size={18} />
//                     <span className="text-sm">{social.label}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* Footer Bottom */}
//           <div className="pt-8 border-t border-white/20">
//             <div className="flex flex-col md:flex-row justify-between items-center gap-4">
//               <p className="text-lg">© Josie Phones & Gadgets Store. All Rights Reserved.</p>
//               <p className="text-lg">
//                 Shop | Trade-in | Repair | Gift cards | Support | Contact
//               </p>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Home;